// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-27T17:05:57.787Z
// Property: Visions (ID: 5185857371766784)
// Collections: 34 amenities, 24 floorplans (live), 27 photos, 39 POIs, 3 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5726763346821120",
  "multihub_property_id": "5185857371766784",
  "property_external_id": "1125113",
  "property_zillow_url": "https://www.zillow.com/homedetails/13720-N-88th-Ave-Peoria-AZ-85381/147059777_zpid/",
  "property_apartments_url": "https://www.apartments.com/visions-peoria-az/rrhksc3",
  "property_google_business_url": "https://www.google.com/maps/place/Visions+Apartment+Homes/data=!4m2!3m1!1s0x0:0xad520ff58c02b4f8?sa=X&ved=2ahUKEwiY_9TLsrmSAxWTk2oFHbyoMSIQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": "https://ch.linkedin.com/company/visionapartments#:~:text=VISIONAPARTMENTS%2C%20established%20in%20Switzerland%20in,temporary%20living%20solutions%20in%20Europe.",
  "property_hubspot_id": "47715877006",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "visions",
  "property_name": "Visions",
  "property_website_url": "https://www.visionsapartments.com/",
  "property_domain": "https://www.visionsapartments.com/",
  "property_address": "13720 North 88th Ave.",
  "property_full_address": "13720 N 88th Ave, Peoria, AZ 85381",
  "property_address_1": "13720 N 88th Ave",
  "property_address_2": null,
  "property_address_city": "Peoria",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85381",
  "property_address_country": "US",
  "property_address_county": "Maricopa County",
  "property_neighborhood_address": "Sun City Lakes Fe",
  "property_address_latitude": "33.6074289",
  "property_address_longitude": "-112.2499513",
  "property_email": "visions@weidner.com",
  "property_phone": "(623) 745-1923",
  "property_call_tracking_phone": "623-745-1923",
  "property_company_name": "Weidner Apartment Homes",
  "property_company_url": "https://www.weidner.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Discover your perfect home at Visions in Peoria, AZ! Choose from spacious studio, one, two, or three-bedroom floor plans. Enjoy amenities like a smoke-free community, convenient online payments, and stunning pool and courtyard views. Dog and cat friendly, Visions is the ideal place to call home. Find your new home today!",
  "property_long_description": "Welcome to Visions, your ideal apartment community nestled in the heart of beautiful Peoria, AZ. Our diverse range of floor plans includes studio, one, two, and three-bedroom apartments designed with modern living in mind. Each unit offers exceptional features, from luxurious granite countertops and mirrored closet doors to inviting garden tubs in select units – ensuring comfort and style at every turn.\n\nOur community is not just about aesthetics; it prioritizes your convenience and lifestyle. Enjoy the ease of online payments, lease agreements from 3 to 12 months, and the ability to submit maintenance requests with just a click. Embrace the outdoors with a beautiful courtyard view, or unwind by our sparkling pool. We are proud to be a smoke-free community that welcomes your furry friends, as we offer a dog and cat-friendly environment.\n\nAt Visions, our resident activity center provides a vibrant space for social gatherings and community events, perfect for meeting neighbors and making lasting connections. Take advantage of covered parking, and rest easy knowing you have access to the Cox Quick Connect Program for all your connectivity needs.\n\nWhether you’re looking for a cozy studio or a spacious three-bedroom, Visions has the perfect home for you. Experience a lifestyle of comfort, convenience, and connection in Peoria. Find your new home today – browse our availability or schedule a tour to visit our welcoming community!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d06e6-88bb-7389-a726-06307c3b0a96.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, outdoor dining area with covered seating.",
    "public_id": "019d06e6-88bb-7389-a726-06307c3b0a96",
    "storage_key": "property/5185857371766784/019d06e6-88bb-7389-a726-06307c3b0a96.webp",
    "width": 1920,
    "height": 702
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "731",
  "property_year_built": "2009",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "93.84404924760602",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "400-500",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "200",
  "property_pet_deposit": "200",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Cats and dogs are welcome (no other pets); Maximum 2 pets per unit; Breed restrictions apply (e.g., Pit Bull and mixes, American Staffordshire Terrier, Wolf Hybrids, Doberman Pinscher, Saint Bernard, American Bulldog, Staffordshire Bull Terrier, Rottweiler, German Shepherd, Chow Chow, Great Dane, Akita). Certified service dogs allowed; reasonable accommodations considered case-by-case.",
  "property_pet_policy_description": "Cats and dogs are welcome (no other pets). Maximum 2 pets per unit. Monthly pet rent: $25 per pet. Non‑refundable pet fee: $200 per pet. Refundable pet deposit: $200 per pet. No weight limit, but breed restrictions apply (e.g., Pit Bull and mixes, American Staffordshire Terrier, Wolf Hybrids, Doberman Pinscher, Saint Bernard, American Bulldog, Staffordshire Bull Terrier, Rottweiler, German Shepherd, Chow Chow, Great Dane, Akita). Certified service dogs allowed; reasonable accommodations considered case‑by‑case.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://visionsapartments.securecafe.com/onlineleasing/visions-0/floorplans.aspx",
  "property_resident_portal_url": "https://visionsapartments.securecafenet.com/residentservices/visions-0/userlogin",
  "property_apply_now_url": "https://visionsapartments.securecafe.com/onlineleasing/visions-0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-374b-741c-bcd6-36a520e96a72.webp",
  "property_primary_logo_media": {
    "alt_text": "Visions Apartment Homes logo",
    "public_id": "019d019e-374b-741c-bcd6-36a520e96a72",
    "storage_key": "property/5185857371766784/019d019e-374b-741c-bcd6-36a520e96a72.webp",
    "width": 2592,
    "height": 802
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-7350-7172-a6b1-8c0fb38dcb5d.webp",
  "property_secondary_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d019e-7350-7172-a6b1-8c0fb38dcb5d",
    "storage_key": "property/5185857371766784/019d019e-7350-7172-a6b1-8c0fb38dcb5d.webp",
    "width": 325,
    "height": 97
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-374b-741c-bcd6-36a520e96a72.webp",
  "property_fav_icon_media": {
    "alt_text": "Visions Apartment Homes logo",
    "public_id": "019d019e-374b-741c-bcd6-36a520e96a72",
    "storage_key": "property/5185857371766784/019d019e-374b-741c-bcd6-36a520e96a72.webp",
    "width": 2592,
    "height": 802
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-36db-7412-9fdd-a9206c8e9b0e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Visions Apartment Homes logo.",
    "public_id": "019d019e-36db-7412-9fdd-a9206c8e9b0e",
    "storage_key": "property/5185857371766784/019d019e-36db-7412-9fdd-a9206c8e9b0e.webp",
    "width": 2592,
    "height": 802
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-36ba-74cb-b052-7586649f93f8.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Visions Apartment Homes logo",
    "public_id": "019d019e-36ba-74cb-b052-7586649f93f8",
    "storage_key": "property/5185857371766784/019d019e-36ba-74cb-b052-7586649f93f8.webp",
    "width": 2592,
    "height": 802
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
  "property_company_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d0198-5322-7081-947b-e809ba802b6c",
    "storage_key": "company/5726763346821120/019d0198-5322-7081-947b-e809ba802b6c.webp",
    "width": 1342,
    "height": 402
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-bdc5-779e-a400-a391326cc801",
    "storage_key": "company/5726763346821120/019d270e-bdc5-779e-a400-a391326cc801.webp",
    "width": 640,
    "height": 192
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Weidner Apartment Homes logo",
    "public_id": "019d270e-c548-748f-97de-b042810ed358",
    "storage_key": "company/5726763346821120/019d270e-c548-748f-97de-b042810ed358.webp",
    "width": 640,
    "height": 192
  },
  "property_primary_color": "#e90400",
  "property_secondary_color": "#000000",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "studio - 3",
  "property_bedrooms_min": "studio",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": " - 1062",
  "property_sqft_min": "474",
  "property_sqft_max": "1062",
  "property_price_range": "950 - 4155",
  "property_price_min": "950",
  "property_price_max": "4155",
  "property_available_units": 67,
  "property_facebook_url": "https://www.facebook.com/VisionsApartmentHomes",
  "property_instagram_url": "https://www.instagram.com/visionsapartments/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJz8Tzk21CK4cR-LQCjPUPUq0",
  "property_youtube_url": "https://www.youtube.com/@WeidnerApartmentHomes",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Discover Your New Home at Visions Apartments in Peoria, AZ",
  "property_home_romance_title": "Welcome to Visions in Peoria",
  "property_home_amenities_blurb": "At Visions in Peoria, AZ, your ideal living space awaits. From cozy studios to spacious three-bedroom apartments, each home is designed for comfort and style. Enjoy unparalleled amenities, including a refreshing pool, fitness center, and vibrant community events, all crafted to enrich your lifestyle. Make your vision a reality today!",
  "property_home_floorplans_blurb": "Welcome to Visions, Peoria's premier apartment community where comfort meets style. With flexible floor plans ranging from studios to spacious three-bedroom apartments, your ideal living space awaits. Browse our available homes today and embrace a lifestyle designed for modern living in the heart of Arizona.",
  "property_home_gallery_blurb": "Welcome to Visions in beautiful Peoria, AZ, where modern living meets a vibrant lifestyle. Choose from spacious studios to luxurious three-bedroom apartments, each designed with top-notch amenities. Enjoy planned social activities, a fitness center, and serene walking trails. What are you waiting for? Picture yourself living here!",
  "property_home_neighborhood_blurb": "<p>Living at Visions puts you right where you want to be. Whether you're cheering on a game at State Farm Stadium, catching a movie at P83 Entertainment District, or picking up essentials at Safeway and Fry's, everything's a quick trip away. Easy access to Loop 101, I-10, and I-17 means you can reach work, school, or a weekend adventure in Peoria, Glendale, or Phoenix with ease. Get some fresh air at Rio Vista Community Park or walk along the New River. No matter your routine, home at Visions gives you access to what you need.</p>",
  "property_home_reviews_blurb": "Discover a welcoming community at Visions in Peoria, AZ, where friendly staff and resident activities create a vibrant atmosphere. With glowing reviews highlighting our excellent amenities and dedicated management, you’ll find a home that feels just right. Step into comfort and community—your ideal living experience awaits!",
  "property_neighborhood_blurb": "<p>At Visions in Peoria, AZ, experience life where everything connects. Pick up groceries at Safeway and Fry's, enjoy shopping at Westgate, Arrowhead Towne Center, and P83 Entertainment District, and catch live events at State Farm Stadium - all just minutes away. Your new home offers easy access to Loop 101, I-10, and I-17, making commutes to downtown Phoenix or Glendale a breeze. Let weekends find you walking along the New River, relaxing at Rio Vista Community Park, or watching baseball at Peoria Sports Complex. Live close to everything and return to comfort every day at Visions.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Come home to comforts and conveniences at Visions. Inside your apartment, enjoy perks like an in-unit washer and dryer, oversized closets, hardwood flooring, and select features, including granite countertops and garden tubs. Step outside to a suite of amenities where you can stay active in the 24-hour fitness center, catch up on work using the clubhouse WiFi, or soak up the Arizona sun by the outdoor swimming pool and spa. Pet-friendly policies and trail access round out your lifestyle.</p>",
  "property_applynow_blurb": "Discover your perfect home at Visions, Peoria's premier apartment community. Choose from spacious studio, one, two, and three-bedroom floor plans, complete with modern amenities like online payments, a resident activity center, and gorgeous courtyard and pool views. Apply now and lease online today for a smoke-free lifestyle full of comfort!",
  "property_contactus_blurb": "<p>Have questions or want to learn more about Visions Apartments in Peoria, AZ? Our leasing team is ready to connect and provide expert guidance to support you in your move. Whether you're curious about floor plans, amenities, or next steps, we're happy to help!</p>",
  "property_faqs_blurb": "Welcome to Visions in Peoria, AZ! Discover our diverse floor plans, including studio, one-bedroom, two-bedroom, and three-bedroom options to suit your lifestyle. Have questions? Browse our FAQs page to find the answers you need about our vibrant community and enjoy a seamless living experience.",
  "property_floorplans_blurb": "<p>At Visions in Peoria, AZ, choose a layout that suits your style - from cozy studios to roomy three bedrooms. Each apartment is designed with daily comfort in mind, featuring hardwood flooring and an in-unit washer and dryer for a more convenient lifestyle. Bright spaces and oversized closets make staying organized effortless, and kitchens with a full appliance package make meal prepping a breeze. Whether you're nesting or sharing with roommates, you'll find room to spread out and personalize your space.</p>",
  "property_gallery_blurb": "<p>Step into the photo gallery and imagine calling Visions home. Browse images of sleek kitchens, airy living rooms, and relaxing bedrooms designed for comfort. Explore community scenes that offer sparkling pool days, efficient workout sessions at the 24-hour fitness center, and moments to unwind on nearby trails. Let the visuals spark your next move.</p>",
  "property_interactivemap_blurb": "Discover your perfect home at Visions in Peoria, AZ! Choose from stylish studio, one, two, and three-bedroom floor plans, all featuring modern amenities like granite countertops and garden tubs. Enjoy a smoke-free community with convenient online payments and maintenance requests. Explore our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "At Visions in Peoria, AZ, your pet will thrive in a vibrant community designed for comfort. Our spacious apartments offer the perfect backdrop for shared adventures. With nearby parks and pet-friendly spaces, every day is an opportunity for fun and exploration with your furry companion by your side.",
  "property_referafriend_blurb": "At Visions in Peoria, AZ, we offer a variety of floor plans, including studios, one, two, and three-bedroom apartments, catering to different lifestyles. Great friends make great neighbors—refer a friend to our vibrant community today and unlock exclusive rewards! Explore all our options and join us!",
  "property_residentaccess_blurb": "Welcome to Visions, your ideal apartment community in Peoria, AZ! Choose from our studio, one, two, or three-bedroom floor plans tailored to your needs. Access your resident portal to effortlessly pay rent, schedule maintenance, and explore additional services. Join us today and enhance your living experience at Visions!",
  "property_reviews_blurb": "At Visions in Peoria, AZ, residents appreciate the friendly atmosphere and engaging community events. One satisfied tenant shared, “The staff is very friendly, and they provide free breakfast for all residents!” Join us for a unique living experience that blends comfort and connection—see what our residents have to say!",
  "property_created_at": "1748533858805",
  "property_scheduletour_blurb": "<p>Finding your new home at Visions is all about ease. Pick the tour that works for you - an in-person look at our community, a guided virtual tour from your favorite chair, or a video walkthrough any time. Our friendly leasing team makes every step clear and helpful. Just schedule, show up, or log in, and start picturing your next home. Restrictions may apply for certain tour options; reach out for details.</p>",
  "property_thankyou_blurb": "Thank you for your interest in Visions, an exceptional apartment community in Peoria, AZ! With a variety of floor plans, from cozy studios to spacious three-bedroom units, there's something for everyone. A team member will reach out shortly to assist you in finding your perfect home. Stay tuned!",
  "property_virtualtours_blurb": "<p>Get an up-close look at Visions Apartment Homes, wherever you are, with our virtual tours. Digitally explore spacious floor plans and open living spaces, soak in the inviting atmosphere, and envision your life in Peoria. From gourmet kitchens and bright living rooms to landscaped courtyard views and cozy clubhouse spaces, everything comes to life on your own device. Thinking of stopping by in person? Our leasing team is just a call away to set up a private visit. Start picturing your next Peoria home - it's all at your fingertips.</p>",
  "property_copyright": "2025 All Rights Reserved. Visions",
  "property_seo_title_home": "Spacious Living | Visions Apartments | Peoria, AZ",
  "property_seo_description_home": "Discover studio, one, two, and three-bedroom homes with in-unit laundry, pet-friendly living, and trail access at Visions Apartments in Peoria, AZ.",
  "property_seo_title_floorplans": "Floor Plans | Visions Apartments | Peoria, AZ",
  "property_seo_description_floorplans": "Find your ideal layout at Visions in Peoria, AZ, with studio, 1, 2, and 3-bedroom apartments featuring hardwood flooring and in-unit laundry.",
  "property_seo_title_amenities": "Premium Amenities | Visions Apartments | Peoria, AZ",
  "property_seo_description_amenities": "Enjoy apartment and community amenities, including in-unit laundry, an outdoor pool, a fitness center, and pet-friendly living at Visions in Peoria, AZ.",
  "property_seo_title_gallery": "Photo Gallery | Visions Apartments | Peoria, AZ",
  "property_seo_description_gallery": "Picture life at Visions in Peoria, AZ through our photo gallery. See stylish interiors, vibrant social spaces, and lush outdoor amenities.",
  "property_seo_title_virtualtours": "Virtual Tour | Visions Apartments | Peoria, AZ",
  "property_seo_description_virtualtours": "Virtually explore Visions in Peoria, AZ, and see the layouts and offered lifestyle from anywhere. Picture your life in our community from your own screen.",
  "property_seo_title_interactivemap": "Interactive Map | Visions Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Visions in Peoria, AZ! Choose from a variety of floor plans, including studio, one, two, and three-bedroom apartments. Enjoy top-notch amenities like online payments, a smoke-free community, a resident activity center, and pet-friendly options. Our interactive community map makes it easy to find your new home—search available apartments, view pricing, and explore our stunning courtyard and pool views today! Make Visions your next destination for comfortable living.",
  "property_seo_title_neighborhood": "Neighborhood Guide | Visions Apartments | Peoria, AZ",
  "property_seo_description_neighborhood": "Explore Visions apartments in vibrant Peoria, AZ - near Westgate Entertainment District, P83 Entertainment District, State Farm Stadium, parks, and top dining.",
  "property_seo_title_contact": "Contact Visions Apartments | Peoria, AZ",
  "property_seo_description_contact": "Reach out to the Visions leasing team in Peoria, AZ, today. Fast replies from friendly professionals who are here to help you.",
  "property_seo_title_faqs": "FAQs | Apartments in Peoria, AZ",
  "property_seo_description_faqs": "Discover all you need to know about Visions, your ideal apartment community in Peoria, AZ! Explore our FAQs page for answers about our diverse floor plans, including studios, one, two, and three-bedroom layouts. Learn about our fantastic amenities such as online payments, smoke-free living, a resident activity center, and dog-friendly policies. Whether you're interested in our pool view apartments or the convenience of online maintenance requests, we've got you covered. Browse our FAQs today to find the perfect home for you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Peoria, AZ",
  "property_seo_description_reviews": "Discover why residents love calling Visions in Peoria, AZ, home! Explore our diverse floor plans—from cozy studios to spacious three-bedroom apartments—designed for every lifestyle. Enjoy premium amenities like a resident activity center, dog-friendly spaces, online payment options, and inviting courtyard views. Immerse yourself in our smoke-free community with covered parking, granite countertops, and convenient in-unit laundry facilities. Hear firsthand experiences from our residents and see what makes living at Visions truly special. Explore reviews now!",
  "property_seo_title_applynow": "Apply Now | Apartments in Peoria, AZ",
  "property_seo_description_applynow": "Discover your dream home at Visions in Peoria, AZ! Choose from our diverse floor plans, including studio, one, two, and three-bedroom apartments. Enjoy top-notch amenities like online payments, a resident activity center, and a smoke-free environment. With features like granite countertops, garden tubs, and convenient online maintenance requests, your comfort is our priority. Plus, we’re dog and cat friendly! Don't wait—find your new home and lease online today at Visions!",
  "property_seo_title_residentaccess": "Resident Access | Visions",
  "property_seo_description_residentaccess": "\"Log in to the Visions resident portal in Peoria, AZ! Easily pay rent, schedule maintenance, and access exclusive community updates. Get connected with just a click!\"",
  "property_seo_title_referafriend": "Refer A Friend | Visions",
  "property_seo_description_referafriend": "\"Refer a friend to Visions in Peoria, AZ, and help them discover their perfect home! Great friends make great neighbors—join our vibrant community today. Enjoy exclusive rewards for referrals. Start spreading the word now!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | Visions Apartments | Peoria, AZ",
  "property_seo_description_scheduletour": "Book a tour of Visions apartments in Peoria, AZ. Choose a private in-person tour, live virtual walkthrough, or video tour from home.",
  "property_seo_title_privacy": "Privacy Policy | Visions",
  "property_seo_description_privacy": "Discover your peace of mind at Visions in Peoria, AZ. Our comprehensive privacy policy ensures your personal information is safeguarded while enjoying modern apartment living. View our privacy policy to learn how we protect your data.",
  "property_seo_title_accessibility": "Website Accessibility | Visions",
  "property_seo_description_accessibility": "\"Discover how Visions, your premier apartment community in Peoria, AZ, champions digital inclusion with our accessibility statement. We believe everyone deserves a seamless online experience. Explore our commitment to accessibility and join a community that values you.\"",
  "property_seo_title_sitemap": "Sitemap | Visions",
  "property_seo_description_sitemap": "\"Explore Visions in Peoria, AZ! Navigate our sitemap to discover the amenities, floor plans, and community features that make us the ideal place to call home. Click to view our comprehensive sitemap now!\"",
  "property_seo_title_thankyou": "Thank You | Visions",
  "property_seo_description_thankyou": "\"Thank you for reaching out to Visions in Peoria, AZ! We appreciate your interest in our vibrant apartment community. A team member will be in touch soon to assist you with your inquiries. Stay tuned for the exciting possibilities that await at Visions!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Peoria, AZ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791842917799",
  "amenities": [
    {
      "id": "ec_706b25b828a4150735955452",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565325",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_017d52eeece2e99a5f341659",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87567257",
      "title": "24-hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/01a114bf-dd3c-766d-9937-5a583f3f687c.webp",
      "amenity_image_media": {
        "alt_text": "Gym with treadmills and weight machines",
        "public_id": "01a114bf-dd3c-766d-9937-5a583f3f687c",
        "storage_key": "property/5185857371766784/01a114bf-dd3c-766d-9937-5a583f3f687c.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cb1677d24f842c1ca4c5cb5d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87620982",
      "title": "Clubhouse WiFi Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6229e8e49abc29e9378e10e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565330",
      "title": "Rentable Garage Parking (Limited)",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_89c20e9d6bbec7f7da010db5",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565340",
      "title": "Swimming pool/spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-2935-770e-b452-3633a4bb6bb8.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and hot tub area with lounge chairs and umbrellas.",
        "public_id": "019d019c-2935-770e-b452-3633a4bb6bb8",
        "storage_key": "property/5185857371766784/019d019c-2935-770e-b452-3633a4bb6bb8.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": ",",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57de62458ba1d980f1206045",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565341",
      "title": "Wireless Internet Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8030a9b9239821d4296fc77e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565324",
      "title": "Online Payments Available",
      "amount": "false",
      "description": "Free e-check option\r\nAccepts credit card payments\r\nAccepts cash payments via MoneyGram",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ec0d4d082957faecf308388b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565328",
      "title": "Courtyard View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b4e01fbae50d83ac4ef08ce",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565334",
      "title": "Online lease agreements 3-15 months",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_49dd8d48dbf8921787e200b3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565335",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5a02b68879e3b15afc61d677",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565336",
      "title": "Online Rent Payment",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_288cd614781699878f3ca241",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565337",
      "title": "Dog and Cat Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_36b6ea19420ebe9b25d1c733",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565338",
      "title": "Pool View",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9458f6d30b4257c47b586ab8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565339",
      "title": "Resident Activity Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4b2ad59d2c864005d7e79176",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "88069580",
      "title": "Smoke-Free Community",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1a8b3b4f57d06f195610e092",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565342",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c1b2de943f8b82398c3c30a2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565343",
      "title": "Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0d570095eedb76c64794c74",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565344",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d1432b66ebf2f8b63ba2a152",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565345",
      "title": "Ceiling Fans*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77bf2d94bcd024d5adf5d00c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565347",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/01a114bf-dd3b-7528-b88e-07f7e5787bd7.webp",
      "amenity_image_media": {
        "alt_text": "Kitchen area with wooden cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a114bf-dd3b-7528-b88e-07f7e5787bd7",
        "storage_key": "property/5185857371766784/01a114bf-dd3b-7528-b88e-07f7e5787bd7.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": ",",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_070dc1eecc3498298a1e9c5f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565351",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b7784d6cc67ff25243dbc28a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565352",
      "title": "Oversized Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e370541cbbd593ef10a29860",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565353",
      "title": "Stainless Steel/Black Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/01a114bf-dd3d-74bd-a542-8999220f3846.webp",
      "amenity_image_media": {
        "alt_text": "Community lounge with coffee bar, mini-fridges, and seating area.",
        "public_id": "01a114bf-dd3d-74bd-a542-8999220f3846",
        "storage_key": "property/5185857371766784/01a114bf-dd3d-74bd-a542-8999220f3846.webp",
        "width": 1024,
        "height": 683
      },
      "amenity_image_alt_text": ",",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_564dc639555a0260350698c2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565354",
      "title": "Washer/Dryer in Unit",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66c42795d39ba8496544f94c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565346",
      "title": "Covered Parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_97eccae1c657b48b55a22034",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565348",
      "title": "Garden Tub*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0953a3621561641fa4c9ad38",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87565349",
      "title": "Granite countertops*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4e21207805e60775d727f1de",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87620990",
      "title": "Courtyard View*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4975a117185eeafa54893da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87620991",
      "title": "Pool View*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_422b030eb2491ffad72f04da",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87620992",
      "title": "Mirrored Closet Doors",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7997b43278903ae6c8d8ce48",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "87620993",
      "title": "Track Lighting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_626fd51ed4746d2690b00fa3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "89441206",
      "title": "Washer Dryer in Bathroom in Select Energy B2 Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd8752c8aa5dc264874a3da2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "123224221",
      "title": "Spectrum Quick Connect",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_57a01768c8d9caca2aa9bbca",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "yardi",
      "external_id": "89469855",
      "title": "Washer/Dryer off Kitchen in Select Studio Units",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5693cb47b360328f668b3fb2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-12a7-74dc-96eb-6dc8ea925f67.webp",
      "image_media": {
        "alt_text": "Living room with sofa, coffee table, television, and plants.",
        "public_id": "019d019c-12a7-74dc-96eb-6dc8ea925f67",
        "storage_key": "property/5185857371766784/019d019c-12a7-74dc-96eb-6dc8ea925f67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and elegantly furnished living room featuring a comfortable sofa, modern coffee table, entertainment center with TV, and decorative plants, creating a welcoming atmosphere.",
      "link": "false",
      "alt_text": "Living room with sofa, coffee table, television, and plants.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-41.JPG"
    },
    {
      "id": "ec_a65c9ee43d7bba14376a2faf",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-676b-753c-93f5-95a58201dd65.webp",
      "image_media": {
        "alt_text": "Dining area and living room with view into bedroom",
        "public_id": "019d4772-676b-753c-93f5-95a58201dd65",
        "storage_key": "property/5185857371766784/019d4772-676b-753c-93f5-95a58201dd65.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit and furnished dining area and living room, with a view into a neatly made bedroom. This space offers a comfortable and stylish living experience.",
      "link": "false",
      "alt_text": "Dining area and living room with view into bedroom",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-43.JPG"
    },
    {
      "id": "ec_f4125896ecbc6dec4fed6992",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-67d3-773e-95d5-949affd8cd57.webp",
      "image_media": {
        "alt_text": "Studio apartment living area with kitchen island, dining table, and bedroom visible through doorway.",
        "public_id": "019d4772-67d3-773e-95d5-949affd8cd57",
        "storage_key": "property/5185857371766784/019d4772-67d3-773e-95d5-949affd8cd57.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious studio apartment featuring an open-concept living area with a modern kitchen, dining space, and a separate bedroom for privacy. Enjoy a comfortable and stylish living experience.",
      "link": "false",
      "alt_text": "Studio apartment living area with kitchen island, dining table, and bedroom visible through doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Visions-Serenity_Favorites (3).jpg"
    },
    {
      "id": "ec_432c8c428bbe8ca9791363f4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aed-bbdb-762f-8bde-a34df1f7f085.webp",
      "image_media": {
        "alt_text": "Dining area with a glass table and chairs, opening to a bedroom and a balcony.",
        "public_id": "019d7aed-bbdb-762f-8bde-a34df1f7f085",
        "storage_key": "property/5185857371766784/019d7aed-bbdb-762f-8bde-a34df1f7f085.webp",
        "width": 3072,
        "height": 1728
      },
      "title": "Apartment",
      "description": "Enjoy dining in this bright apartment, which features a spacious balcony and a view into a comfortable bedroom.",
      "link": "false",
      "alt_text": "Dining area with a glass table and chairs, opening to a bedroom and a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/Arizona_Visions-Apartment-Homes_Apartment_2-Bedroom_Model-Unit-1_Dining-Room-1.jpg"
    },
    {
      "id": "ec_f983f9acad20563695bcb74e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "image_media": {
        "alt_text": "Kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-equipped kitchen featuring stainless steel appliances, granite countertops, and ample cabinet space. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with stainless steel appliances, granite countertops, and wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-16.JPG"
    },
    {
      "id": "ec_ba512593b0678e0254133329",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-51cf-71ac-a625-2d99ab322540.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light wood cabinets, black appliances including a microwave and stove, and a stainless steel refrigerator.",
        "public_id": "019d019c-51cf-71ac-a625-2d99ab322540",
        "storage_key": "property/5185857371766784/019d019c-51cf-71ac-a625-2d99ab322540.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this spacious kitchen featuring ample cabinet storage, a full suite of black appliances, and a sleek countertop.",
      "link": "false",
      "alt_text": "Modern kitchen with light wood cabinets, black appliances including a microwave and stove, and a stainless steel refrigerator.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Visions-Serenity_Favorites (6).jpg"
    },
    {
      "id": "ec_2d9fee6ef5c2abfb7e97f59a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-6890-757f-b334-b15dcaf6d954.webp",
      "image_media": {
        "alt_text": "Modern kitchen with black appliances, stainless steel sink, and light wood cabinets.",
        "public_id": "019d4772-6890-757f-b334-b15dcaf6d954",
        "storage_key": "property/5185857371766784/019d4772-6890-757f-b334-b15dcaf6d954.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This updated kitchen features a full suite of black appliances, including a microwave, oven, and refrigerator, complemented by sleek countertops and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern kitchen with black appliances, stainless steel sink, and light wood cabinets.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-28.JPG"
    },
    {
      "id": "ec_3e55b1670b48675fd911199b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-55cd-732c-a912-cefa2c64b6ee.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, walk-in closet, and view of an en-suite bathroom.",
        "public_id": "019d019c-55cd-732c-a912-cefa2c64b6ee",
        "storage_key": "property/5185857371766784/019d019c-55cd-732c-a912-cefa2c64b6ee.webp",
        "width": 2560,
        "height": 1707
      },
      "title": "Apartment",
      "description": "Charming bedroom featuring a comfortable queen-size bed, ample closet space, and convenient access to an en-suite bathroom. The inviting decor and thoughtful layout create a relaxing retreat.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, walk-in closet, and view of an en-suite bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Visions-Serenity_Favorites (8).jpg"
    },
    {
      "id": "ec_bd8e8638cfc5ab1260c3b30f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aed-dafe-751b-b3f5-796dff9c7574.webp",
      "image_media": {
        "alt_text": "Bedroom with a dresser, mirror, and a view into the dining area.",
        "public_id": "019d7aed-dafe-751b-b3f5-796dff9c7574",
        "storage_key": "property/5185857371766784/019d7aed-dafe-751b-b3f5-796dff9c7574.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a large dresser, decorative mirror, and ample closet space. Enjoy an open view into the dining area.",
      "link": "false",
      "alt_text": "Bedroom with a dresser, mirror, and a view into the dining area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-47.JPG"
    },
    {
      "id": "ec_5795d24d3a5a7cc177d05bcd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-6ed4-76ed-a0b6-6b45e2dbc4d1.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, nightstands, and a large mirror.",
        "public_id": "019d4772-6ed4-76ed-a0b6-6b45e2dbc4d1",
        "storage_key": "property/5185857371766784/019d4772-6ed4-76ed-a0b6-6b45e2dbc4d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A beautifully decorated bedroom featuring a king-size bed with plush pillows, elegant nightstands, and a decorative mirror above the headboard.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, nightstands, and a large mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-24.JPG"
    },
    {
      "id": "ec_414c1bc82960a998eee9f2e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-7068-710f-996a-6cf4aada54b2.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and closet.",
        "public_id": "019d4772-7068-710f-996a-6cf4aada54b2",
        "storage_key": "property/5185857371766784/019d4772-7068-710f-996a-6cf4aada54b2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a comfortable queen-size bed, elegant dresser, and ample closet space, perfect for relaxation.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and closet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-20.JPG"
    },
    {
      "id": "ec_5ef61ad9d7d6ffe3001d8285",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-7638-774d-80e5-4d88c10dbd49.webp",
      "image_media": {
        "alt_text": "Bathroom with bathtub, toilet, and vanity with sink and mirror.",
        "public_id": "019d4772-7638-774d-80e5-4d88c10dbd49",
        "storage_key": "property/5185857371766784/019d4772-7638-774d-80e5-4d88c10dbd49.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This bathroom features a bathtub/shower combo, a toilet, and a vanity with a sink. The vanity has ample counter space and storage, and the mirror reflects the hallway outside.",
      "link": "false",
      "alt_text": "Bathroom with bathtub, toilet, and vanity with sink and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-44.JPG"
    },
    {
      "id": "ec_0f92e2ae72a0e226458339e7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aee-442d-7299-9fb8-c22e9fd40666.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
        "public_id": "019d7aee-442d-7299-9fb8-c22e9fd40666",
        "storage_key": "property/5185857371766784/019d7aee-442d-7299-9fb8-c22e9fd40666.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Enjoy the sunshine or find shade under the cabana.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and a covered cabana.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-28.JPG"
    },
    {
      "id": "ec_9199a38db389d17dd5abb4dd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aee-6eb5-70ea-80e0-59d18bae557d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "019d7aee-6eb5-70ea-80e0-59d18bae557d",
        "storage_key": "property/5185857371766784/019d7aee-6eb5-70ea-80e0-59d18bae557d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and lush palm trees. Perfect for relaxing and soaking up the sun.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-35.JPG"
    },
    {
      "id": "ec_aabfd265b8ec7b03896d5f8c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-7b48-714c-917f-070aacd52764.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and umbrellas",
        "public_id": "019d4772-7b48-714c-917f-070aacd52764",
        "storage_key": "property/5185857371766784/019d4772-7b48-714c-917f-070aacd52764.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, complete with comfortable lounge chairs and refreshing umbrellas.",
      "link": "false",
      "alt_text": "Swimming pool with lounge chairs and umbrellas",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-9.JPG"
    },
    {
      "id": "ec_2dd3a2672073ac09573d23f0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aee-609b-719c-ae55-761c368bad3e.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and seating area by the pool with lounge chairs.",
        "public_id": "019d7aee-609b-719c-ae55-761c368bad3e",
        "storage_key": "property/5185857371766784/019d7aee-609b-719c-ae55-761c368bad3e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our built-in barbecue grill and covered seating area, perfect for relaxing by the pool.",
      "link": "false",
      "alt_text": "Outdoor kitchen and seating area by the pool with lounge chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-34.JPG"
    },
    {
      "id": "ec_de86385f11a524cf8fbdf528",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-3857-7462-90e2-7486bdcd8824.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and weight machines, large windows overlooking the courtyard.",
        "public_id": "019d019c-3857-7462-90e2-7486bdcd8824",
        "storage_key": "property/5185857371766784/019d019c-3857-7462-90e2-7486bdcd8824.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring state-of-the-art treadmills and weight machines. Enjoy your workout with a view of the beautiful courtyard.",
      "link": "false",
      "alt_text": "Fitness center with treadmills and weight machines, large windows overlooking the courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-18.JPG"
    },
    {
      "id": "ec_e07430d50e3fb867d1ade626",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-7f9e-751b-aa10-b05272854ea0.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a well-lit fitness center with large windows.",
        "public_id": "019d4772-7f9e-751b-aa10-b05272854ea0",
        "storage_key": "property/5185857371766784/019d4772-7f9e-751b-aa10-b05272854ea0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, featuring treadmills, ellipticals, and other cardio equipment. Perfect for your daily workout routine.",
      "link": "false",
      "alt_text": "Treadmills and elliptical machines in a well-lit fitness center with large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-17.JPG"
    },
    {
      "id": "ec_82639a3365dd6a9aab97ff7d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-3e6b-753a-b795-0fed6a0bc217.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, free weights, and yoga mats",
        "public_id": "019d019c-3e6b-753a-b795-0fed6a0bc217",
        "storage_key": "property/5185857371766784/019d019c-3e6b-753a-b795-0fed6a0bc217.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines, weight training equipment, and a dedicated space for yoga and stretching.",
      "link": "false",
      "alt_text": "Gym with weight machines, free weights, and yoga mats",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-12.JPG"
    },
    {
      "id": "ec_df73cab0430db323488790a0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-8257-7659-a17f-31b7daa267c0.webp",
      "image_media": {
        "alt_text": "Lobby seating area with fireplace and large windows",
        "public_id": "019d4772-8257-7659-a17f-31b7daa267c0",
        "storage_key": "property/5185857371766784/019d4772-8257-7659-a17f-31b7daa267c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the spacious and comfortable lobby, perfect for relaxing or socializing, featuring a modern fireplace and ample seating.",
      "link": "false",
      "alt_text": "Lobby seating area with fireplace and large windows",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-2.JPG"
    },
    {
      "id": "ec_0905ad957a58a181ccb864f3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-8379-779d-9290-7189a345c15f.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen and lounge area overlooking the pool.",
        "public_id": "019d4772-8379-779d-9290-7189a345c15f",
        "storage_key": "property/5185857371766784/019d4772-8379-779d-9290-7189a345c15f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our modern outdoor kitchen and lounge area, perfect for entertaining guests or relaxing by the pool.",
      "link": "false",
      "alt_text": "Outdoor kitchen and lounge area overlooking the pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-4.JPG"
    },
    {
      "id": "ec_fc1720dc37b349110186aa9e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-36f6-729d-8917-0285011b569e.webp",
      "image_media": {
        "alt_text": "Community coffee bar with seating and decorative elements.",
        "public_id": "019d019c-36f6-729d-8917-0285011b569e",
        "storage_key": "property/5185857371766784/019d019c-36f6-729d-8917-0285011b569e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy complimentary coffee and refreshments at our stylish community coffee bar, perfect for a quick pick-me-up or a casual chat.",
      "link": "false",
      "alt_text": "Community coffee bar with seating and decorative elements.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-serentiy-1.JPG"
    },
    {
      "id": "ec_ffb40f0b05699f72d736f338",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-88ec-76c7-85eb-95d1a2cae9d1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a TV, comfortable seating, and large windows overlooking a pool.",
        "public_id": "019d4772-88ec-76c7-85eb-95d1a2cae9d1",
        "storage_key": "property/5185857371766784/019d4772-88ec-76c7-85eb-95d1a2cae9d1.webp",
        "width": 1024,
        "height": 683
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish lounge, perfect for socializing or enjoying a quiet moment. Features a large screen TV and scenic views of the pool area.",
      "link": "false",
      "alt_text": "Modern lounge area with a TV, comfortable seating, and large windows overlooking a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/AZ_Visions-Serenity_Favorites (23).JPG"
    },
    {
      "id": "ec_f82a089ce4f2fa37407e43d0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aee-c9ab-77bf-961c-df24de4aba4c.webp",
      "image_media": {
        "alt_text": "Billiards room with a pink felt pool table and a television.",
        "public_id": "019d7aee-c9ab-77bf-961c-df24de4aba4c",
        "storage_key": "property/5185857371766784/019d7aee-c9ab-77bf-961c-df24de4aba4c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in our community's billiards room, featuring a stylish pool table and entertainment TV.",
      "link": "false",
      "alt_text": "Billiards room with a pink felt pool table and a television.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-19.JPG"
    },
    {
      "id": "ec_5e28c8ed6fb37ceefd8c07e1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-8b6c-746a-88c8-81548cd139e8.webp",
      "image_media": {
        "alt_text": "Community game room with foosball and shuffleboard tables and a TV.",
        "public_id": "019d4772-8b6c-746a-88c8-81548cd139e8",
        "storage_key": "property/5185857371766784/019d4772-8b6c-746a-88c8-81548cd139e8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy endless entertainment in the community game room, featuring foosball, shuffleboard, and a large television for your enjoyment.",
      "link": "false",
      "alt_text": "Community game room with foosball and shuffleboard tables and a TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-21.JPG"
    },
    {
      "id": "ec_67b7229237f27314e73a670a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d4772-900a-754a-ad51-696c949c6c37.webp",
      "image_media": {
        "alt_text": "Covered outdoor seating area with tables, chairs, ceiling fan, and TV.",
        "public_id": "019d4772-900a-754a-ad51-696c949c6c37",
        "storage_key": "property/5185857371766784/019d4772-900a-754a-ad51-696c949c6c37.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor living with this covered seating area, complete with tables, chairs, ceiling fan, and a TV for entertainment.",
      "link": "false",
      "alt_text": "Covered outdoor seating area with tables, chairs, ceiling fan, and TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-12.JPG"
    },
    {
      "id": "ec_a80d619db3541a4e28a0347d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d7aef-3817-70dc-9e5d-5d8abdd287d4.webp",
      "image_media": {
        "alt_text": "Outdoor grilling station with two large stainless steel grills and a sink, next to a residential building.",
        "public_id": "019d7aef-3817-70dc-9e5d-5d8abdd287d4",
        "storage_key": "property/5185857371766784/019d7aef-3817-70dc-9e5d-5d8abdd287d4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy al fresco dining at our community's outdoor grilling station, perfect for social gatherings and enjoying the fresh air.",
      "link": "false",
      "alt_text": "Outdoor grilling station with two large stainless steel grills and a sink, next to a residential building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/111265/visions-energy-15.JPG"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_3804c11e-a7d5-48d7-b528-78f4fdeb62fd",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Topgolf Glendale",
      "poi_type": "Restaurants",
      "poi_address": "6101 N 99th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Comfort food, beers, and cocktails are served in a relaxed restaurant with a golf driving range.",
      "poi_long_description": "People say this restaurant offers a fun golfing experience with various games and a bar. They also highlight the friendly staff, clean and well-maintained space, and the overall fun and engaging atmosphere.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4a76-728a-94bc-79f6782f0d46.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4a76-728a-94bc-79f6782f0d46",
        "storage_key": "property/5185857371766784/019d019d-4a76-728a-94bc-79f6782f0d46.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://topgolf.com/us/glendale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18202148712618417323&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "topgolf-glendale",
      "poi_latitude": "33.5244195",
      "poi_longitude": "-112.2708168",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-218-2243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77fb-76ec-b12d-7d32b462e2d2",
        "storage_key": "property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEeFArr5BK4cRq1x0pNAFm_w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7e92e8aa-799a-41a1-bad0-c825be2c0f25",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Golden Corral Buffet & Grill",
      "poi_type": "Restaurants",
      "poi_address": "5679 W Northern Ave, Glendale, AZ 85301, USA",
      "poi_short_description": "Family-friendly buffet chain featuring all-you-can-eat American fare, plus salad & dessert bars.",
      "poi_long_description": "People say this buffet restaurant offers a wide variety of comfort foods, including pot roast, fried chicken, and steak, as well as a salad bar and desserts. They also highlight the reasonable prices, especially for seniors and lunch, and the friendly and attentive staff.\n\nSome reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4a3d-739a-b21c-70be407115f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4a3d-739a-b21c-70be407115f7",
        "storage_key": "property/5185857371766784/019d019d-4a3d-739a-b21c-70be407115f7.webp",
        "width": 960,
        "height": 721
      },
      "poi_business_url": "https://www.goldencorral.com/locations/2530/golden-corral-w-northern-avenue?utm_source=google&utm_medium=local&utm_campaign=localmaps&utm_content=2530",
      "poi_directions_map_url": "https://maps.google.com/?cid=16146451116213055299&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-corral-buffet--grill",
      "poi_latitude": "33.552664",
      "poi_longitude": "-112.181616",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 623-937-0866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77fb-76ec-b12d-7d32b462e2d2",
        "storage_key": "property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoc_4NKhrK4cRQ68WHb63E-A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "buffet_restaurant"
    },
    {
      "id": "custom_18dfd01d-fc65-4f62-9adc-b6085272eb07",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Yard House",
      "poi_type": "Restaurants",
      "poi_address": "9401 W Westgate Blvd, Glendale, AZ 85305, USA",
      "poi_short_description": "High-end sports-bar chain with a huge menu of New American fare & an extensive list of draft beers.",
      "poi_long_description": "People say this restaurant offers delicious jambalaya, burgers, and calamari, and has a massive selection of beers on tap. They highlight the generous portions, reasonable prices, and lively atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4a9c-77db-983a-6ee4d8bb524b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4a9c-77db-983a-6ee4d8bb524b",
        "storage_key": "property/5185857371766784/019d019d-4a9c-77db-983a-6ee4d8bb524b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.yardhouse.com/locations/az/glendale/glendale-westgate-entertainment-district/8315?cmpid=br:yh_ag:ie_ch:loc_ca:YHGMB_sn:gmb_gt:glendale-az-8315_pl:locurl_rd:1014",
      "poi_directions_map_url": "https://maps.google.com/?cid=834847278677342726&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "yard-house",
      "poi_latitude": "33.5340858",
      "poi_longitude": "-112.2612644",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-872-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77fb-76ec-b12d-7d32b462e2d2",
        "storage_key": "property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdW2bezVAK4cRBrpDPy35lQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_8256cc48-4e43-43e9-a145-038aa66adffb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "16134 N 83rd Ave, Peoria, AZ 85382, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "Diners say this restaurant offers a wide variety of cheesecakes, along with delicious pasta, salmon, and chicken dishes. They also highlight the friendly and attentive service, and the generous portions.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4a90-7148-942d-87779d1b219f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4a90-7148-942d-87779d1b219f",
        "storage_key": "property/5185857371766784/019d019d-4a90-7148-942d-87779d1b219f.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/az/peoria-76.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=13800893377578149106&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "33.6332815",
      "poi_longitude": "-112.2361098",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-773-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77fb-76ec-b12d-7d32b462e2d2",
        "storage_key": "property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_XlvuyloK4cR8iSWGWifhr8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_96f0fb6d-32ba-45de-b825-dc67fb8765f0",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Glendale",
      "poi_type": "Restaurants",
      "poi_address": "9330 W Hanna Ln, Glendale, AZ 85305, USA",
      "poi_short_description": "Rotisserie chicken and other comfort food share a menu with beer, cocktails, and pickleball courts.",
      "poi_long_description": "People say this restaurant offers delicious chicken and waffles, chicken sandwiches, and ribs, as well as fun outdoor games like cornhole and pickleball. They also highlight the friendly and attentive staff, and the fun, lively atmosphere.\n\nOther reviews mention the food can be greasy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4e8c-74d3-bc27-37b7747d25d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4e8c-74d3-bc27-37b7747d25d1",
        "storage_key": "property/5185857371766784/019d019d-4e8c-74d3-bc27-37b7747d25d1.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/glendale/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10503486576134877276&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chicken-n-pickle---glendale",
      "poi_latitude": "33.5355509",
      "poi_longitude": "-112.2599241",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-352-8950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77fb-76ec-b12d-7d32b462e2d2",
        "storage_key": "property/5185857371766784/019d019d-77fb-76ec-b12d-7d32b462e2d2.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZf1ynU1BK4cRXHCaIWThw5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_24b07f2b-1222-4c24-96fc-326bd07f75e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Arrowhead Towne Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "7700 W Arrowhead Towne Center, Glendale, AZ 85308, USA",
      "poi_short_description": "Mall featuring department stores, national chains & a food court, plus free Wi-Fi & a movie theater.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores and dining options. They also highlight the clean, spacious, and easy-to-navigate layout, as well as the convenient parking and safe, well-maintained atmosphere.\n\nSome reviews mention the escalators can be out of service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4ef5-75de-a4fd-fbf2bbddbfcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4ef5-75de-a4fd-fbf2bbddbfcf",
        "storage_key": "property/5185857371766784/019d019d-4ef5-75de-a4fd-fbf2bbddbfcf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.arrowheadtownecenter.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=15024802289062104840&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arrowhead-towne-center",
      "poi_latitude": "33.6420107",
      "poi_longitude": "-112.2253493",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-979-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77ff-7598-b21f-e65a56427dea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77ff-7598-b21f-e65a56427dea",
        "storage_key": "property/5185857371766784/019d019d-77ff-7598-b21f-e65a56427dea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJsWodKDtoK4cRCM8FvBPSgtA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_317b5ead-f516-4e02-b5e2-94144099803e",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Tanger Outlets Phoenix",
      "poi_type": "Shopping & Retail",
      "poi_address": "6800 N 95th Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Shopping-mall chain featuring a variety of brand-name & designer outlet stores.",
      "poi_long_description": "People say this shopping center offers a wide variety of stores, including high-end and outlet options, with good deals and quality products. They highlight the convenient location, ample parking, and shaded areas for a comfortable shopping experience. They also like the fun atmosphere with food trucks and upgraded walking areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-4f86-713b-a9f3-fcadee1cdef0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-4f86-713b-a9f3-fcadee1cdef0",
        "storage_key": "property/5185857371766784/019d019d-4f86-713b-a9f3-fcadee1cdef0.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.tangeroutlet.com/glendale",
      "poi_directions_map_url": "https://maps.google.com/?cid=16253464825419077885&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tanger-outlets-phoenix",
      "poi_latitude": "33.5341547",
      "poi_longitude": "-112.2667464",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 623-877-9500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77ff-7598-b21f-e65a56427dea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77ff-7598-b21f-e65a56427dea",
        "storage_key": "property/5185857371766784/019d019d-77ff-7598-b21f-e65a56427dea.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNyV8OEtAK4cR_Rhp6CToj-E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_ddb020b4-de90-4a65-841c-ecc3c0888e2b",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "8078 W Bell Rd, Glendale, AZ 85308, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of unique snacks, fresh produce, salads, and a variety of wines and beers. They highlight the reasonable prices, good quality food, and the store's clean and well-maintained environment. They also like the friendly, helpful, and efficient staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-501e-7550-97f6-2dfd693fc442.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-501e-7550-97f6-2dfd693fc442",
        "storage_key": "property/5185857371766784/019d019d-501e-7550-97f6-2dfd693fc442.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.traderjoes.com/az/glendale/85/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=17265181746020257326&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "33.6400609",
      "poi_longitude": "-112.2311451",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 928-397-9921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-9cfe3ba85054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-9cfe3ba85054",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-9cfe3ba85054.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBQtZWCVoK4cRLo4YulI_mu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_48e1e395-18a8-4984-88d3-5c9f773ed88d",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Lee Lee International Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "7575 W Cactus Rd, Peoria, AZ 85381, USA",
      "poi_short_description": "Spacious ethnic grocery with fresh produce, meat, seafood & foods imported from 30+ countries.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of international foods, including fresh produce, seafood, spices, and snacks from various countries. They highlight the reasonable prices and the fun, adventurous shopping experience. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-532d-75e5-8683-ca9aacd30adb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-532d-75e5-8683-ca9aacd30adb",
        "storage_key": "property/5185857371766784/019d019d-532d-75e5-8683-ca9aacd30adb.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.leeleesupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15297342196616545134&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lee-lee-international-supermarkets",
      "poi_latitude": "33.5946741",
      "poi_longitude": "-112.221928",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-773-3345",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-9cfe3ba85054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-9cfe3ba85054",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-9cfe3ba85054.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLUxnwPFpK4cRbkPs1K0TS9Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_2b96c96c-3dbd-426e-ba0e-6ec6f65ddcb9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "5850 W Bell Rd, Glendale, AZ 85308, USA",
      "poi_short_description": "Employee-owned 24/7 supermarket chain with discounted groceries & bulk foods, plus a deli & bakery.",
      "poi_long_description": "People say this supermarket offers a wide variety of fresh produce, quality meats, dairy, and bakery items, as well as a large selection of bulk goods, including nuts, grains, seeds, candies, and coffee. They highlight the great prices, the store is always fully stocked, and it's open 24 hours a day. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-536f-750f-91b0-3c119ea92be2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-536f-750f-91b0-3c119ea92be2",
        "storage_key": "property/5185857371766784/019d019d-536f-750f-91b0-3c119ea92be2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4692151506305712643&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "33.6408704",
      "poi_longitude": "-112.183112",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 602-298-2830",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-9cfe3ba85054.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-9cfe3ba85054",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-9cfe3ba85054.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJawiOhv5oK4cRA4KqVe_eHUE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_78ef9c9f-d815-4d41-af75-967bac0dbbab",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Glendale Community College",
      "poi_type": "Education",
      "poi_address": "6000 W Olive Ave, Glendale, AZ 85302, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5493-77ff-837d-31bad10d2403.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5493-77ff-837d-31bad10d2403",
        "storage_key": "property/5185857371766784/019d019d-5493-77ff-837d-31bad10d2403.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gccaz.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=954649757192534245&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-community-college",
      "poi_latitude": "33.5694333",
      "poi_longitude": "-112.1908271",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-845-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-a0d2428b0b03",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ52NxVbVrK4cR5bhfbuWYPw0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_f5248018-be48-44c1-b6de-4fc81531407c",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Midwestern University",
      "poi_type": "Education",
      "poi_address": "19555 N 59th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5485-7304-bbed-16455190081c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5485-7304-bbed-16455190081c",
        "storage_key": "property/5185857371766784/019d019d-5485-7304-bbed-16455190081c.webp",
        "width": 1280,
        "height": 733
      },
      "poi_business_url": "http://www.midwestern.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2223870335671267858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "midwestern-university",
      "poi_latitude": "33.6637764",
      "poi_longitude": "-112.1833108",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-572-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-a0d2428b0b03",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Q_nt45oK4cREvI2qEnG3B4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_190ef644-40e2-4208-9ab7-77a7a4fe01af",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Arizona State University West Valley Campus",
      "poi_type": "Education",
      "poi_address": "4701 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-57f2-7298-8f57-5c894c1497ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-57f2-7298-8f57-5c894c1497ca",
        "storage_key": "property/5185857371766784/019d019d-57f2-7298-8f57-5c894c1497ca.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=14857680985714674109&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-state-university-west-valley-campus",
      "poi_latitude": "33.6079039",
      "poi_longitude": "-112.1609696",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-543-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-a0d2428b0b03",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi7CNmFxpK4cRvUmZGyMWMc4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_47bbd5e9-21f3-48c5-884d-5e96cbd2e9f2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Arizona Christian University",
      "poi_type": "Education",
      "poi_address": "1 W. Firestorm Way, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-58df-75fe-9227-98cf1755acd6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-58df-75fe-9227-98cf1755acd6",
        "storage_key": "property/5185857371766784/019d019d-58df-75fe-9227-98cf1755acd6.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.arizonachristian.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4384916488308923584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-christian-university",
      "poi_latitude": "33.6209932",
      "poi_longitude": "-112.1807676",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 602-489-5300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-a0d2428b0b03",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJufvuEVBpK4cRwBxoV1Ba2jw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7f777fae-c828-4afc-a8c4-d95eb75308c3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "ASU WEST",
      "poi_type": "Education",
      "poi_address": "7000 University Way N, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5964-73a5-80c9-8ef1d3b1c870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5964-73a5-80c9-8ef1d3b1c870",
        "storage_key": "property/5185857371766784/019d019d-5964-73a5-80c9-8ef1d3b1c870.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://campus.asu.edu/west-valley",
      "poi_directions_map_url": "https://maps.google.com/?cid=17607851155726739029&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "asu-west",
      "poi_latitude": "33.6090958",
      "poi_longitude": "-112.160189",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-a0d2428b0b03",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJW3qhzzppK4cRVSYL81WnW_Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_05da146f-2fb4-4550-8bf0-5573574d6ee3",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "State Farm Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1 Cardinals Dr, Glendale, AZ 85305, USA",
      "poi_short_description": "Home of NFL Cardinals games & more, this arena seats 63,000+ & features a retracting roof.",
      "poi_long_description": "People say this stadium offers a variety of events, including concerts, sports games, and shows. They highlight the reasonable prices, clean facilities, and comfortable air conditioning. They also like the friendly and helpful staff, and the organized parking and traffic flow. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5a02-7408-bfbb-3383d7a702c2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5a02-7408-bfbb-3383d7a702c2",
        "storage_key": "property/5185857371766784/019d019d-5a02-7408-bfbb-3383d7a702c2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.statefarmstadium.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13385990751358890075&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "state-farm-stadium",
      "poi_latitude": "33.5276247",
      "poi_longitude": "-112.2625593",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 623-433-7101",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-54ceb614897c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-54ceb614897c",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-54ceb614897c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ3UCqTEhAK4cRWzBplaqXxLk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_36b8abe2-1f98-4017-91cd-44831a0d7465",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Desert Diamond Arena",
      "poi_type": "Entertainment",
      "poi_address": "9400 W Maryland Ave, Glendale, AZ 85305, USA",
      "poi_short_description": "Celebrated multipurpose facility showcases Phoenix Coyotes games, other sporting events & concerts.",
      "poi_long_description": "People say this arena hosts great events and has easy parking, with options including a parking garage located near the entrance. They also highlight the excellent sound and visual systems.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.desertdiamondarena.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5185020725397653236&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-diamond-arena",
      "poi_latitude": "33.532074",
      "poi_longitude": "-112.2612163",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-249-2603",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJy-l2-zVAK4cR9IZd2uDk9Ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_04f254ca-c931-4dd5-9364-23853fa24ddc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Peoria Sports Complex",
      "poi_type": "Entertainment",
      "poi_address": "16101 N 83rd Ave, Peoria, AZ 85382, USA",
      "poi_short_description": "Arena hosting spring training for 2 major baseball teams, plus local leagues & events.",
      "poi_long_description": "People say this stadium offers a wide selection of stadium food, including hot dogs, peanuts, and soft pretzels, and a variety of beers. They highlight the fun, family-friendly vibe, and the spacious, all-outdoor midway, perfect for enjoying the weather. They also like the comfortable seating with ample legroom and good views, and the grassy area beyond left field, ideal for picnics and home run catches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5c88-722b-b4db-ef6d40dcf01f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5c88-722b-b4db-ef6d40dcf01f",
        "storage_key": "property/5185857371766784/019d019d-5c88-722b-b4db-ef6d40dcf01f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peoriasportscomplex.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2168085844272306260&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peoria-sports-complex",
      "poi_latitude": "33.6320953",
      "poi_longitude": "-112.2332781",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-773-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-54ceb614897c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-54ceb614897c",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-54ceb614897c.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJma0WLEVsK4cRVFhnnpaWFh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_89134e0c-f4ff-40e6-b71f-cb7ebaaf4240",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "8235 W Bell Rd, Peoria, AZ 85382, USA",
      "poi_short_description": "Large-scale indoor trampoline center hosting open jump, fitness classes, dodgeball & parties.",
      "poi_long_description": "Visitors say this amusement park offers go-karts, trampolines, a zip line, and laser tag, and they praise the friendly and helpful staff, especially during birthday parties. They also highlight the great value of the memberships, which include pizza and drinks for kids.\n\nSome reviews mention the park can be overcrowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5dc2-719a-b313-86ce504c40ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5dc2-719a-b313-86ce504c40ef",
        "storage_key": "property/5185857371766784/019d019d-5dc2-719a-b313-86ce504c40ef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.urbanair.com/arizona-peoria/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=1278221389060598423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "33.6366112",
      "poi_longitude": "-112.2321447",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-900-6449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuae_cq9pK4cRl2pDv5QnvRE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_188625db-0336-4b8e-8e09-167896e609eb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "7586 W Thunderbird Rd A, Peoria, AZ 85381, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides suitable for both kids and adults, as well as a jungle gym and trampoline area. They highlight the clean facilities and the fun, exciting atmosphere. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5da3-76fd-bc1c-260d5885cf8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5da3-76fd-bc1c-260d5885cf8e",
        "storage_key": "property/5185857371766784/019d019d-5da3-76fd-bc1c-260d5885cf8e.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/az-peoria",
      "poi_directions_map_url": "https://maps.google.com/?cid=16413734618846361541&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "33.6114316",
      "poi_longitude": "-112.2221017",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 623-473-9218",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl8zSFddpK4cRxXfeEaxMyeM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_2e0de2e0-b2ff-485f-a298-c2ae5318ec84",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Banfield Pet Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "9960 N 91st Ave, Peoria, AZ 85345, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-60d8-77be-83ee-6209d87953e2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-60d8-77be-83ee-6209d87953e2",
        "storage_key": "property/5185857371766784/019d019d-60d8-77be-83ee-6209d87953e2.webp",
        "width": 684,
        "height": 514
      },
      "poi_business_url": "https://www.banfield.com/locations/veterinarians/az/peoria/wpe?utm_source=yext&utm_medium=yext&utm_campaign=yext&cid=yext_local",
      "poi_directions_map_url": "https://maps.google.com/?cid=18394545765573899542&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banfield-pet-hospital",
      "poi_latitude": "33.5749175",
      "poi_longitude": "-112.2560652",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 623-334-9801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6wG9AvRBK4cRFrWyUeqNRv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_bc456bdf-8934-4619-87a0-c78d9d6bc93a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Arizona Veterinary Emergency & Critical Care Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7823 W Golden Ln, Peoria, AZ 85345, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-61b9-7249-8ff5-3b5700359476.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-61b9-7249-8ff5-3b5700359476",
        "storage_key": "property/5185857371766784/019d019d-61b9-7249-8ff5-3b5700359476.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.azervets.com/locations/peoria?utm_source=gmb&utm_medium=organic&y_source=1_MTU5MzIzOTctNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=158738173446973287&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "arizona-veterinary-emergency--critical-care-center",
      "poi_latitude": "33.5637295",
      "poi_longitude": "-112.2280501",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 602-491-1928",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZ1TyklrK4cRZ-eZGIfzMwI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_ea098596-dc64-4baa-a075-1bcec25a2dfc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Mountainside Fitness Arrowhead",
      "poi_type": "Health and Wellness",
      "poi_address": "20250 N 75th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "Health-club chain offering weight machines, yoga classes, spin courses and other fitness options.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, classes, and amenities, including childcare, a sauna, and massage chairs. They highlight the clean environment, friendly staff, and welcoming atmosphere. They also like the convenient location and the value for the price.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6245-732c-8881-778bf75a9d9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6245-732c-8881-778bf75a9d9d",
        "storage_key": "property/5185857371766784/019d019d-6245-732c-8881-778bf75a9d9d.webp",
        "width": 320,
        "height": 320
      },
      "poi_business_url": "https://mountainsidefitness.com/locations/arrowhead/?utm_source=GMB&utm_medium=Local&utm_campaign=Arrowhead&utm_content=WebsiteLink",
      "poi_directions_map_url": "https://maps.google.com/?cid=9942410235927687337&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mountainside-fitness-arrowhead",
      "poi_latitude": "33.6689836",
      "poi_longitude": "-112.2226625",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 480-625-0228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3a_n1wtoK4cRqXCts26J-ok",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_33bbb33f-359d-4144-8a7a-ea1d036e6ac2",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "4255 W Thunderbird Rd, Phoenix, AZ 85053, USA",
      "poi_short_description": "Roomy chain facility for gym regulars featuring cardio and weight machines, an indoor pool, free weights and group classes.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including massage chairs, a pool, a sauna, and a steam room, as well as Studio HIIT classes and personal trainers. They also highlight the friendly and helpful staff, the clean facilities, and the welcoming and well-maintained environment.\n\nSome reviews mention the billing practices can be difficult to deal with.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-62de-75d4-9812-5c6b818d4484.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-62de-75d4-9812-5c6b818d4484",
        "storage_key": "property/5185857371766784/019d019d-62de-75d4-9812-5c6b818d4484.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/az/phoenix-thunderbird/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1906049609365793961&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "33.6094223",
      "poi_longitude": "-112.150361",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-603-0811",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd65gug1pK4cRqSyFYgWmcxo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a417dda2-9251-4663-9f2a-dc91c1906096",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "EōS Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8440 W Thunderbird Rd, Peoria, AZ 85381, USA",
      "poi_short_description": "Fitness center offering classes and a 24-hour schedule, plus a pool, a sauna and a kids’ club.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including free weights, machines, and a turf area, as well as amenities like a sauna and a serenity room. They also highlight the clean facility, friendly and welcoming staff, and positive and supportive atmosphere.\n\nOther reviews mention the membership plans can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-5ea0-74b9-9b9c-f0461a3df03d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-5ea0-74b9-9b9c-f0461a3df03d",
        "storage_key": "property/5185857371766784/019d019d-5ea0-74b9-9b9c-f0461a3df03d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://eosfitness.com/gym/peoria/?utm_source=local&utm_medium=organic&utm_campaign=evergreen_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11183106934043517370&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "es-fitness",
      "poi_latitude": "33.61150920000001",
      "poi_longitude": "-112.2407923",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 623-388-3461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbUz9cHZCK4cRuiHfgIFgMps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_59581d37-55ee-4466-bfc4-d3e9284106e9",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Desert Tumbling",
      "poi_type": "Health and Wellness",
      "poi_address": "21501 N 78th Ave #105, Peoria, AZ 85382, USA",
      "poi_short_description": "Gym featuring open tumbling and classes for all levels, plus skilled coaches.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-64d9-746e-9e2a-9bb462fbf0f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-64d9-746e-9e2a-9bb462fbf0f0",
        "storage_key": "property/5185857371766784/019d019d-64d9-746e-9e2a-9bb462fbf0f0.webp",
        "width": 662,
        "height": 1280
      },
      "poi_business_url": "http://www.deserttumbling.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6584472805098198409&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "desert-tumbling",
      "poi_latitude": "33.67935600000001",
      "poi_longitude": "-112.226477",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-362-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-77f8-72d8-b295-a0d2428b0b03",
        "storage_key": "property/5185857371766784/019d019d-77f8-72d8-b295-a0d2428b0b03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJw6CbyvpnK4cRiRUZVSG_YFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d87f5514-54b7-44c9-8434-0e63ab257f26",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Banner Thunderbird Medical Center | Glendale, AZ | Thunderbird Rd.",
      "poi_type": "Health and Wellness",
      "poi_address": "5555 W Thunderbird Rd, Glendale, AZ 85306, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-65d5-7678-b8d1-67a434651d4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-65d5-7678-b8d1-67a434651d4d",
        "storage_key": "property/5185857371766784/019d019d-65d5-7678-b8d1-67a434651d4d.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/glendale/banner-thunderbird-medical-center?y_source=1_MTE5MDczNTItNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=11031221542305799944&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-thunderbird-medical-center--glendale-az--thunderbird-rd",
      "poi_latitude": "33.6093624",
      "poi_longitude": "-112.1801493",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 602-865-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b59-710b-8deb-f65180b52ab4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b59-710b-8deb-f65180b52ab4",
        "storage_key": "property/5185857371766784/019d019d-7b59-710b-8deb-f65180b52ab4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJnx4Z3nFpK4cRCB_G-4vFFpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_2db2ddb8-71ae-43c5-87a7-729e8fc9b02f",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Banner Boswell Medical Center Sun City",
      "poi_type": "Health and Wellness",
      "poi_address": "10401 W Thunderbird Blvd, Sun City, AZ 85351, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-668e-77bf-9038-ce5ff0b62832.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-668e-77bf-9038-ce5ff0b62832",
        "storage_key": "property/5185857371766784/019d019d-668e-77bf-9038-ce5ff0b62832.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.bannerhealth.com/locations/sun-city/banner-boswell-medical-center?y_source=1_MTE5MDczNjEtNzE1LWxvY2F0aW9uLndlYnNpdGU=",
      "poi_directions_map_url": "https://maps.google.com/?cid=8895627802108364922&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "banner-boswell-medical-center-sun-city",
      "poi_latitude": "33.604096",
      "poi_longitude": "-112.2820456",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 623-832-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b59-710b-8deb-f65180b52ab4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b59-710b-8deb-f65180b52ab4",
        "storage_key": "property/5185857371766784/019d019d-7b59-710b-8deb-f65180b52ab4.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVW9DA01CK4cRegjC3lqec3s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_85ce4076-b4f8-4ba1-a41e-da34ad672feb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Pioneer Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8755 N 83rd Ave, Peoria, AZ 85345, USA",
      "poi_short_description": "Spacious public park featuring a 5-acre lake, sports fields, a splash pad, dog area & BBQ grills.",
      "poi_long_description": "People say this park offers a playground, splash pad, pond for fishing, and paved paths for walking. They highlight the park is clean, fun for kids of all ages, and has plenty of tables and shaded areas. They also like the large grass area for sports activities and the separate dog park areas. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-679b-74fc-97cf-428bf1e10421.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-679b-74fc-97cf-428bf1e10421",
        "storage_key": "property/5185857371766784/019d019d-679b-74fc-97cf-428bf1e10421.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peoriaaz.gov",
      "poi_directions_map_url": "https://maps.google.com/?cid=11355508877434622827&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pioneer-community-park",
      "poi_latitude": "33.5622759",
      "poi_longitude": "-112.2340009",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 623-773-7137",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b5f-74cc-98f3-bca3df5eb9f8",
        "storage_key": "property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJG2aP7HRqK4cRaxNJ8yjflp0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1597ce07-38c9-4c94-839b-00e3a4138223",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Rio Vista Community Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8866 W Thunderbird Rd, Peoria, AZ 85381, USA",
      "poi_short_description": "Spacious park featuring ponds, a skate park and playgrounds.",
      "poi_long_description": "People say this park offers a variety of recreational activities, including a playground, splash pad, skate park, sports fields, and walking trails. They highlight the clean and well-maintained facilities, and the beautiful scenery with a pond, ducks, and geese. They also like the ample parking, shaded areas, and ramadas available for rent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6955-7709-98a1-da2e530a8371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6955-7709-98a1-da2e530a8371",
        "storage_key": "property/5185857371766784/019d019d-6955-7709-98a1-da2e530a8371.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peoriaaz.gov/riovista",
      "poi_directions_map_url": "https://maps.google.com/?cid=8898296229423108388&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rio-vista-community-park",
      "poi_latitude": "33.6152629",
      "poi_longitude": "-112.2445353",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 623-773-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b5f-74cc-98f3-bca3df5eb9f8",
        "storage_key": "property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAaGmLG5CK4cRJFH2hEYZfXs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eadc5c12-4768-4a01-8a35-5fd6aac278c1",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Sahuaro Ranch Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9802 59th Ave, Glendale, AZ 85302, USA",
      "poi_short_description": "Set on old ranch grounds, this park features wandering fowl, a historic house museum & play areas.",
      "poi_long_description": "Visitors say this park offers a historic atmosphere with beautiful grounds, peacocks roaming freely, and playgrounds for children. They also highlight the abundance of picnic tables, barbecue pits, and walking paths, making it an ideal spot for outdoor activities and family gatherings.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6a05-762c-a7f4-71eb86a5fa94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6a05-762c-a7f4-71eb86a5fa94",
        "storage_key": "property/5185857371766784/019d019d-6a05-762c-a7f4-71eb86a5fa94.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "http://www.glendaleaz.com/parksandrecreation/sahuaroranchpark.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=12960466992835098622&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sahuaro-ranch-park",
      "poi_latitude": "33.5765875",
      "poi_longitude": "-112.1906328",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b5f-74cc-98f3-bca3df5eb9f8",
        "storage_key": "property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQbuutctrK4cR_ncc_w_U3LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_715028f9-fef7-4cd7-932e-3ab5ddc912cc",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Glendale Heroes Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "83rd Avenue and, Bethany Home Rd, Glendale, AZ 85303, USA",
      "poi_short_description": "A city park with playgrounds, water play area, skate & BMX facility, picnicking, basketball & more.",
      "poi_long_description": "People say this park offers multiple playgrounds, fishing, a skate park, a dog park, pickleball courts, and a library. They highlight the park is clean, spacious, and has a beautiful lake with walking trails, as well as picnic areas and barbecue grills. They also like the recent upgrades, including new fields, play areas, and walking spaces.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6b49-758e-a8d3-d803f9337d5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6b49-758e-a8d3-d803f9337d5a",
        "storage_key": "property/5185857371766784/019d019d-6b49-758e-a8d3-d803f9337d5a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.glendaleaz.com/parksandrecreation/GlendaleHeroesPark.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=15557125583860822947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-heroes-regional-park",
      "poi_latitude": "33.5263956",
      "poi_longitude": "-112.2364476",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 623-930-2820",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b5f-74cc-98f3-bca3df5eb9f8",
        "storage_key": "property/5185857371766784/019d019d-7b5f-74cc-98f3-bca3df5eb9f8.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJjd7tH5xqK4cRo3MqGEsD5tc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b5f613f0-be0f-4fff-89dc-5c24312a12bb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Bellair Golf Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "17233 N 45th Ave, Glendale, AZ 85308, USA",
      "poi_short_description": "Golf course with an 18-hole short course and driving range, plus an on-site restaurant.",
      "poi_long_description": "People say this golf course offers a fun, short course perfect for practicing irons and a driving range with ball tracking technology. They highlight the well-maintained greens, fluffy white sand in the bunkers, and the friendly and helpful staff. They also like the reasonable prices and relaxing vibe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6c51-7570-bbc6-56cce3007cb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6c51-7570-bbc6-56cce3007cb6",
        "storage_key": "property/5185857371766784/019d019d-6c51-7570-bbc6-56cce3007cb6.webp",
        "width": 702,
        "height": 395
      },
      "poi_business_url": "https://www.bellairgolfpark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8406907117581785615&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bellair-golf-park",
      "poi_latitude": "33.6428631",
      "poi_longitude": "-112.1567792",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 37 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 602-513-7070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7e7a-701a-b356-9daaa9cc4a7c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7e7a-701a-b356-9daaa9cc4a7c",
        "storage_key": "property/5185857371766784/019d019d-7e7a-701a-b356-9daaa9cc4a7c.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3deUYXVpK4cRD1oqU3tVq3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_fef649bf-eecd-4faf-8f7e-15ac500e3d99",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Glendale Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "6801 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6e61-72e0-a3f4-a0be61e855ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6e61-72e0-a3f4-a0be61e855ec",
        "storage_key": "property/5185857371766784/019d019d-6e61-72e0-a3f4-a0be61e855ec.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.glendaleaz.com/live/amenities/airport",
      "poi_directions_map_url": "https://maps.google.com/?cid=6794599642740604503&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "glendale-regional-airport",
      "poi_latitude": "33.5296849",
      "poi_longitude": "-112.2972206",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-930-2188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7e75-70be-a27a-ce0b01c5df29.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7e75-70be-a27a-ce0b01c5df29",
        "storage_key": "property/5185857371766784/019d019d-7e75-70be-a27a-ce0b01c5df29.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0ED0OVAK4cRV76MMGBES14",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_3d0f18f7-530d-41c3-ab4f-9b00f837f402",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Avanti",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12501 W Olive Ave, El Mirage, AZ 85335, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-6eff-73d9-9b7c-8130e76b7f70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-6eff-73d9-9b7c-8130e76b7f70",
        "storage_key": "property/5185857371766784/019d019d-6eff-73d9-9b7c-8130e76b7f70.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13260930301790480076&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "avanti",
      "poi_latitude": "33.565338",
      "poi_longitude": "-112.3286404",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 605-600-8706",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd3F-VrlBK4cRzGZvndlJCLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_399a332a-7d23-44f6-8d57-e81613233205",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Peoria City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8401 W Monroe St, Peoria, AZ 85345, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7010-7218-8c86-80f1738541fb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-7010-7218-8c86-80f1738541fb",
        "storage_key": "property/5185857371766784/019d019d-7010-7218-8c86-80f1738541fb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.peoriaaz.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=700068911782228049&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "peoria-city-hall",
      "poi_latitude": "33.5759342",
      "poi_longitude": "-112.2397897",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 623-773-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7e78-7213-a140-9afc827fac0a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7e78-7213-a140-9afc827fac0a",
        "storage_key": "property/5185857371766784/019d019d-7e78-7213-a140-9afc827fac0a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXWmixv1BK4cRUfASVfcktwk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_1537d01d-a498-452e-81f4-cfaeb29b4ae8",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "83rd Avenue & Thunderbird",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14155 N 83rd Ave #101, Peoria, AZ 85381, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7110-72fb-a96b-3b3f051644d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-7110-72fb-a96b-3b3f051644d8",
        "storage_key": "property/5185857371766784/019d019d-7110-72fb-a96b-3b3f051644d8.webp",
        "width": 800,
        "height": 1168
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8676213151083001908&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "83rd-avenue--thunderbird",
      "poi_latitude": "33.6128063",
      "poi_longitude": "-112.2367872",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 623-412-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJL26sY9hpK4cRNPjfceQZaHg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_2094bbb8-8922-4354-9033-40c47b7453c7",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "TYR Tactical",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9330 N 91st Ave, Peoria, AZ 85345, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7256-7309-89f2-8c2b3e51d9f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-7256-7309-89f2-8c2b3e51d9f6",
        "storage_key": "property/5185857371766784/019d019d-7256-7309-89f2-8c2b3e51d9f6.webp",
        "width": 1088,
        "height": 725
      },
      "poi_business_url": "https://www.tyrtactical.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16471192394524991071&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tyr-tactical",
      "poi_latitude": "33.5691766",
      "poi_longitude": "-112.2556371",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 623-240-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZRgRoNCK4cRXx7H9jZuleQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9746a948-0222-4325-9ea4-51632500fd78",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "poi_name": "Conair Corporation",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7475 N Glen Harbor Blvd, Glendale, AZ 85307, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-73cb-754f-bd5b-c34ecd3e2517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d019d-73cb-754f-bd5b-c34ecd3e2517",
        "storage_key": "property/5185857371766784/019d019d-73cb-754f-bd5b-c34ecd3e2517.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.conair.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9226046055308480358&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "conair-corporation",
      "poi_latitude": "33.5415218",
      "poi_longitude": "-112.2857174",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 623-872-8750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d019d-7b3f-75b6-8db5-59d17f71f603",
        "storage_key": "property/5185857371766784/019d019d-7b3f-75b6-8db5-59d17f71f603.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2QzD8QdBK4cRZk8OcAGACYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_e7c4beff721469c4f71e29b7",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f2da9e9ed940f4c62691425f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_4674c7e50cb69494ea10e6f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_08ae32543138ca66b81bea49",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_51d3ab4b46b9dd75b5acbcaa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_29d1fe2f4323c02eeea85d65",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_7b727c8d-05d8-4b9f-87bc-acaea81e0510",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "rating": "5.0",
      "name": "Kelly Ann White",
      "text": "Had the most painless experience getting my apartment at Visions. Let me tell you, I was ready to give up my search with how discouraged I was getting trying to find my dream home. Aden made this such an easy experience and I’m so excited to move in next month! What a beautiful community and apartments. You can really tell they take care of their property. Thank you Visions for making my dream come true!",
      "date": "2025-02-04",
      "title": ""
    },
    {
      "id": "custom_47d1e5f1-06dd-436d-b87a-1fd7dfb935fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "rating": "5.0",
      "name": "B Scarlett",
      "text": "I walked in without an appointment, feeling a bit confused and out of place as four people looked at me without acknowledging me. Just as I was about to leave, a young woman named Christina walked in with a customer and immediately greeted me. She kindly asked if I had been helped, and when I said no, she let me know she was wrapping up a tour and would assist me next. In the meantime, she offered me water and popcorn which was such a thoughtful touch. Honestly, I was ready to walk out, but Christina completely changed the experience for me. While availability at the property was limited, the apartments were beautiful, and the entire property was well-maintained. Christina was informative, funny, and remembered every detail I mentioned was important to me. She never pressured me to lease, which made me feel confident and comfortable when I decided to apply. She truly should be the first face people see when they walk in—warm, welcoming, and professional. I give this place 10 stars 5 for the property and 5 for Christina.",
      "date": "2025-09-13",
      "title": "false"
    },
    {
      "id": "custom_3475ccc2-8e4a-4a77-966f-d2661be4e305",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "rating": "5.0",
      "name": "Xtina Baker",
      "text": "Review for Mike – Maintenance Team\n\nI’d like to recognize Mike from the maintenance team for his outstanding work and dedication. He consistently ensures that the units he prepares are 100% move-in ready, paying close attention to every detail. Mike is efficient, reliable, and it’s clear he takes great pride in the quality of his work. His efforts make a noticeable difference in providing a smooth experience for our new residents. Christina- Visions Apartment Homes Associate.",
      "date": "2025-10-24",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_6582b208-0f6c-4c0b-a4cc-426fdda7cd9a",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-2b0b-74c8-9369-b7e47723f21c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living area and kitchen in a modern apartment.",
        "public_id": "019d019e-2b0b-74c8-9369-b7e47723f21c",
        "storage_key": "property/5185857371766784/019d019e-2b0b-74c8-9369-b7e47723f21c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Visions Apartment Homes | 1 Bedroom | Model Unit 1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=nDZuL4oWwmM"
    },
    {
      "id": "custom_c799ff67-bde5-4aad-aa50-d5f4dcc6fce6",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-2b0b-74c8-9369-b3a0d48b9338.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen area with a view into a bedroom.",
        "public_id": "019d019e-2b0b-74c8-9369-b3a0d48b9338",
        "storage_key": "property/5185857371766784/019d019e-2b0b-74c8-9369-b3a0d48b9338.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Visions Apartment Homes | 1 Bedroom | Model Unit 2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=9TaUe3nQBuh"
    },
    {
      "id": "custom_f8df7c96-539a-46a7-910a-a9bd131dbb43",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-2c1f-7611-8ee0-8549e25c091d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with double sink and granite countertops overlooking living room with sectional sofa and balcony.",
        "public_id": "019d019e-2c1f-7611-8ee0-8549e25c091d",
        "storage_key": "property/5185857371766784/019d019e-2c1f-7611-8ee0-8549e25c091d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Visions Apartment Homes | 2 Bedroom | Model Unit 1",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ReyzatoGazB"
    },
    {
      "id": "custom_3deee66c-1168-4aed-9f16-df0d985015ee",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019e-2b98-70be-a23c-f2d834e5ef3d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and kitchen of a multifamily apartment.",
        "public_id": "019d019e-2b98-70be-a23c-f2d834e5ef3d",
        "storage_key": "property/5185857371766784/019d019e-2b98-70be-a23c-f2d834e5ef3d.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Visions Apartment Homes | 2 Bedroom | Model Unit 2",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zdS1n5wisfT"
    },
    {
      "id": "custom_f079a7ea-2987-4f92-82df-77ff34acf381",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d06e6-77f6-7376-addd-820d425cf8a4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with granite countertops, wood cabinets, stainless steel appliances, and a breakfast bar.",
        "public_id": "019d06e6-77f6-7376-addd-820d425cf8a4",
        "storage_key": "property/5185857371766784/019d06e6-77f6-7376-addd-820d425cf8a4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Visions Apartment Homes | Serenity B2 | 2BR, 2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=oFPL6j8sjhC"
    },
    {
      "id": "custom_dc9ffcc6-bf18-4760-b4da-b7f81ddc4afb",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d06e6-7826-741f-8412-b5774d43de71.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Kitchen with black appliances, wood cabinets, and granite countertops.",
        "public_id": "019d06e6-7826-741f-8412-b5774d43de71",
        "storage_key": "property/5185857371766784/019d06e6-7826-741f-8412-b5774d43de71.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Visions Apartment Homes | Energy B3 | 2BR, 2BA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=VKc1y6rujcg"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0198aa47-80ae-722a-a5cd-dc40133f911b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "visions",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784"
    },
    {
      "lead_collector_id": "0198aa47-8112-73c6-8749-acb9966fe169",
      "lead_source": "FACEBOOK_ADS",
      "name": "visions",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784"
    },
    {
      "lead_collector_id": "0198aa47-8174-7054-917c-f8423eef88f6",
      "lead_source": "LANDING_PAGE",
      "name": "visions",
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "apartments-with-pool-peoria-az",
      "search_query": "apartments with pool in Peoria AZ",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Peoria AZ",
      "h2_subtitle": "Experience the joy of living in Peoria, AZ with access to a stunning pool. Our community offers luxurious poolside relaxation.",
      "page_copy": "Discover the perfect balance of comfort and leisure at Visions, your ultimate choice in Peoria, AZ for apartments with a pool. Situated in the serene Sun City Lakes Fe neighborhood, Visions offers an exceptional lifestyle for those seeking both convenience and luxury. Dive into relaxation with our pristine pool, the heart of our community, complemented by views of our beautifully landscaped courtyard.\n\nAt Visions, we offer a variety of spacious floor plans ranging from studios to three-bedroom homes, perfect for any lifestyle. Our pet-friendly community ensures that both you and your furry friends feel right at home. With additional amenities like a fitness center and the convenience of online payments, you'll find everything you need to enjoy life in Peoria, AZ. Immerse yourself in a community designed with your comfort in mind and discover the best of apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Peoria AZ – Visions",
      "seo_description": "Discover Visions in Peoria, AZ with a stunning pool and view. Choose from a range of spacious floor plans in a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-near-85381",
      "search_query": "fitness center apartments near 85381",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments Near 85381",
      "h2_subtitle": "Discover premium apartments near 85381 with a modern fitness center. Enhance your lifestyle at our well-equipped community.",
      "page_copy": "Stay active and thrive at Visions, the top choice for those seeking fitness center apartments near 85381. Our Peoria, AZ community is perfectly located in the Sun City Lakes Fe neighborhood, providing convenience and accessibility to all nearby attractions. At Visions, our state-of-the-art fitness center is designed to cater to all your workout needs, ensuring you can maintain an active lifestyle right at home.\n\nBeyond our fitness amenities, Visions offers a variety of layouts from studios to three-bedroom homes, ideal for every resident. Whether you're relaxing on your balcony or enjoying the hardwood floors, our apartments provide an exceptional living experience. With a pet-friendly policy, both you and your furry companions will feel right at home. Embrace a balanced lifestyle with convenient online payments and the serenity of smoke-free living at Visions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments Near 85381 – Visions",
      "seo_description": "Explore Visions near 85381! Our fitness center, pet-friendly homes, and varied floor plans offer the perfect blend of convenience and comfort.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "furnished-apartments-sun-city-lakes-fe",
      "search_query": "furnished apartments in Sun City Lakes Fe",
      "category": "Amenity",
      "h1_title": "Furnished Apartments in Sun City Lakes Fe",
      "h2_subtitle": "Explore our stylish furnished apartments in Sun City Lakes Fe. Enjoy a comfortable lifestyle with all the modern amenities you desire.",
      "page_copy": "Situated in the serene Sun City Lakes Fe neighborhood in Peoria, AZ, Visions offers furnished apartments that redefine modern living. Our community combines contemporary style with practical convenience, perfect for those seeking an immediate and hassle-free move-in experience. These furnished residences are thoughtfully designed to provide comfort and sophistication while allowing you to enjoy the full range of on-site amenities.\n\nWhether you're lounging by the pool or maintaining your workout routine in our fitness center, every aspect of Visions is crafted to enhance your lifestyle. Choose from a selection of floor plans that suit your needs, all within a pet-friendly and smoke-free community. Take advantage of online payment options and enjoy the elegantly landscaped surroundings from your own private balcony. Discover the ideal furnished apartment home at Visions today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Furnished Apartments in Sun City Lakes Fe – Visions",
      "seo_description": "Discover furnished living at Visions in Sun City Lakes Fe. Enjoy stylish interiors and modern amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-peoria",
      "search_query": "dog friendly apartments in Peoria",
      "category": "Amenity",
      "h1_title": "Dog Friendly Apartments in Peoria",
      "h2_subtitle": "Find the perfect dog friendly apartment in Peoria. Our community welcomes you and your pets with open arms and fantastic amenities.",
      "page_copy": "Welcome to Visions, where you and your four-legged friends can experience the best in dog friendly apartments in Peoria. Nestled in the charming Sun City Lakes Fe neighborhood, Visions is tailored for pet lovers who seek a community that values their pets as much as they do. Our spacious grounds and ideal living spaces are perfect for you and your furry companions to explore and enjoy.\n\nChoose from a range of floor plans that provide comfort and style, with features like hardwood floors and private balconies. Our pet-friendly community offers amenities such as a beautiful pool and a fitness center, ensuring that all residents, including your pets, enjoy a vibrant and active lifestyle. With convenient online payments and smoke-free living, Visions is the ideal place for you and your pet to call home in Peoria, AZ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Friendly Apartments in Peoria – Visions",
      "seo_description": "Explore Visions in Peoria for dog-friendly living. Enjoy spacious layouts, amenities, and a welcoming community for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "apartments-air-conditioning-peoria-az",
      "search_query": "apartments with air conditioning Peoria AZ",
      "category": "Amenity",
      "h1_title": "Apartments with Air Conditioning in Peoria, AZ",
      "h2_subtitle": "Discover cool comfort at our Peoria, AZ apartments. Our air-conditioned homes offer a refreshing escape from the Arizona heat.",
      "page_copy": "Beat the Arizona heat at Visions, where apartments with air conditioning in Peoria, AZ are designed for ultimate comfort. Located in the tranquil Sun City Lakes Fe neighborhood, our community offers a refreshing retreat with all the conveniences you need. Keep cool year-round in our well-appointed residences, ensuring a cozy environment regardless of the outdoor temperatures.\n\nBeyond air conditioning, Visions features a variety of floor plans with luxurious touches like hardwood floors and spacious balconies. Our amenity-rich environment includes a modern fitness center and beautifully landscaped common areas. Whether you're enjoying the pet-friendly atmosphere or the hassle-free living with online payment options, Visions provides a serene haven you'll love coming home to.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments in Peoria, AZ – Visions",
      "seo_description": "Stay cool at Visions in Peoria, AZ. Our air-conditioned apartments offer comfort and style with amenities like a fitness center and pool.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "studio-apartments-peoria-az",
      "search_query": "studio apartments Peoria AZ",
      "category": "Floorplan",
      "h1_title": "Studio Apartments in Peoria, AZ",
      "h2_subtitle": "Find charming studio apartments in Peoria, AZ. Experience the blend of comfort and convenience at Visions, where vibrant living awaits.",
      "page_copy": "Welcome to Visions, the perfect destination for those seeking studio apartments in Peoria, AZ. Our community aligns modern conveniences with a welcoming environment, making it an excellent choice for a fresh start. Each studio is thoughtfully designed, featuring efficient layouts that maximize space and comfort while providing the ideal setting for your lifestyle needs.\n\nLocated in the Sun City Lakes Fe neighborhood, Visions offers more than just spacious living. Enjoy a range of community amenities such as a fitness center and sparkling pool. Appreciate stunning views from your balcony or explore the pet-friendly grounds with your furry friend. With easy online payments and a smoke-free environment, living at Visions exemplifies ease and style. Discover your new home in Peoria today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Studio Apartments in Peoria, AZ – Visions",
      "seo_description": "Explore Visions in Peoria, AZ for stylish studio apartments. Enjoy efficient layouts, modern amenities, and vibrant community living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-peoria-85381",
      "search_query": "one bedroom apartments 85381",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in 85381",
      "h2_subtitle": "Explore our one bedroom apartments in the 85381 area. Experience comfort and style at Visions, located in Peoria, AZ.",
      "page_copy": "Discover the serene living at Visions, your go-to place for one bedroom apartments in the 85381 ZIP code. Located in the heart of Peoria, AZ, this community provides an ideal blend of comfort and convenience. Our one-bedroom layouts are designed with you in mind, offering spacious and well-appointed interiors that set the stage for your unique lifestyle.\n\nAt Visions, residents enjoy a host of premium amenities, including a modern fitness center and lush courtyard views. Each apartment features hardwood floors and private balconies, enhancing both style and comfort. Whether you're relaxing by the pool or utilizing our pet-friendly spaces, Visions offers the perfect environment for a balanced and enriching living experience in Peoria.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments 85381 – Visions",
      "seo_description": "Find beautiful one-bedroom apartments in Peoria, 85381. At Visions, enjoy stylish interiors and community amenities for a superior living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-sun-city-lakes",
      "search_query": "two bedroom apartments Sun City Lakes",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Sun City Lakes",
      "h2_subtitle": "Discover spacious two bedroom apartments in Sun City Lakes. Visions offers the perfect home with modern amenities and prime location.",
      "page_copy": "Welcome to Visions, where finding two bedroom apartments in Sun City Lakes is both easy and rewarding. Situated in Peoria, AZ, our community is tailored to provide comfort and convenience for families, roommates, or individuals seeking extra space. Our two-bedroom layouts offer generous living areas, modern finishes, and a layout that maximizes both functionality and aesthetics.\n\nNestled in the picturesque Sun City Lakes neighborhood, Visions ensures a rich living experience with exceptional amenities including a state-of-the-art fitness center and inviting pool area. Each apartment boasts hardwood floors and private balconies, allowing for personal retreat and relaxation. With pet-friendly policies and a stress-free atmosphere, Visions stands out as a premier choice for two-bedroom living in Peoria.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Sun City Lakes – Visions",
      "seo_description": "Explore Visions for two bedroom apartments in Sun City Lakes. Enjoy spacious layouts and top amenities in a prime Peoria, AZ location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-phoenix",
      "search_query": "three bedroom apartments near Phoenix",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Phoenix",
      "h2_subtitle": "Explore spacious three bedroom apartments near Phoenix. Visions in Peoria, AZ offers perfect homes for everyone with premium amenities.",
      "page_copy": "Discover Visions, where three bedroom apartments near Phoenix promise a blend of space and convenience. Situated in Peoria, AZ, our community is ideal for families or those who need extra room. Each three-bedroom unit provides ample living space with stylish features perfect for a modern lifestyle.\n\nOur residents enjoy access to top-tier amenities including a well-equipped fitness center and a beautiful pool. Additional conveniences like online payments and pet-friendly policies enhance the living experience. Located near the vibrant Sun City Lakes neighborhood, Visions offers the perfect suburban retreat with easy access to the Phoenix area. Choose Visions for a comfortable and convenient living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Phoenix – Visions",
      "seo_description": "Find spacious three-bedroom apartments near Phoenix at Visions. Experience comfort with modern amenities in a convenient Peoria location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "apartments-near-thunderbird-west-campus",
      "search_query": "apartments near thunderbird west campus peoria",
      "category": "School",
      "h1_title": "Apartments Near Thunderbird West Campus",
      "h2_subtitle": "Discover ideal apartments near Thunderbird West Campus in Peoria. Visions offers comfort and convenience in a prime location.",
      "page_copy": "Explore Visions, the perfect choice for those seeking apartments near Thunderbird West Campus in Peoria. Our community offers a variety of spacious floor plans, including studio, one, two, and three-bedroom options, designed with modern living in mind. Enjoy easy access to the campus while relishing the comfort of a sophisticated apartment with amenities that meet your lifestyle needs.\n\nLocated in Peoria, Visions is surrounded by the serene beauty of the Sun City Lakes neighborhood. Residents enjoy premium amenities such as a state-of-the-art fitness center, inviting pool, and pet-friendly spaces. With hardwood floors and private balconies, each apartment provides the right blend of style and function. Choose Visions as your home base, where the best of both student life and suburban relaxation are at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Thunderbird West Campus – Visions",
      "seo_description": "Find ideal apartments near Thunderbird West Campus at Visions in Peoria. Enjoy modern living with top amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "places-to-live-close-to-asu-west",
      "search_query": "places to live close to arizona state university west",
      "category": "School",
      "h1_title": "Places to Live Near ASU West",
      "h2_subtitle": "Discover amazing places to live close to Arizona State University West. Visions offers ideal accommodations in Peoria with fantastic amenities.",
      "page_copy": "Explore Visions, one of the best places to live close to Arizona State University West. Located in Peoria, our community provides a comfortable and convenient living experience for students and professionals alike. We offer a variety of floor plans including studio, one, two, and three-bedroom options, all within easy commuting distance to ASU West.\n\nAmenities at Visions are designed to enhance your lifestyle, featuring a well-equipped fitness center, a refreshing pool, and spacious balconies. Our pet-friendly policy and smoke-free environment further add to the allure of living here. Nestled in the scenic Sun City Lakes neighborhood, Visions is the perfect home base for those seeking a balanced life close to education and entertainment hubs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Places to Live Near ASU West – Visions",
      "seo_description": "Discover Visions in Peoria, a great place to live near Arizona State University West with convenient amenities and spacious living options.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "apartments-near-glendale-community-college",
      "search_query": "apartments near glendale community college az",
      "category": "School",
      "h1_title": "Apartments Near Glendale Community College AZ",
      "h2_subtitle": "Find exceptional apartments near Glendale Community College, AZ. Visions in Peoria offers a perfect blend of comfort and accessibility.",
      "page_copy": "Visions is your ideal destination if you're searching for apartments near Glendale Community College, AZ. Situated in Peoria, our community provides outstanding apartment living with close proximity to the college, making it an excellent choice for students and faculty members alike. Choose from various flexible layouts, including studio, one, two, and three-bedroom floor plans, designed with modern conveniences.\n\nResidents of Visions enjoy superb amenities such as a comprehensive fitness center and a pristine swimming pool. Our pet-friendly community supports your lifestyle, offering additional conveniences including a linen closet, hardwood floors, and easy online payments. Located in the charming Sun City Lakes area, Visions offers not just a place to stay but a place to thrive close to Glendale Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Glendale Community College AZ – Visions",
      "seo_description": "Discover Visions' apartments near Glendale Community College, AZ. Enjoy modern living with top-notch amenities in Peoria.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "find-apartments-near-midwestern-university-maricopa",
      "search_query": "find apartments near midwestern university maricopa county",
      "category": "School",
      "h1_title": "Find Apartments Near Midwestern University",
      "h2_subtitle": "Discover the best way to find apartments near Midwestern University in Maricopa County. Visions offers convenient, stylish living options in Peoria.",
      "page_copy": "Searching for the perfect place to find apartments near Midwestern University in Maricopa County? Look no further than Visions, situated in Peoria. Our community is ideal for students and professionals alike, with easy access to campus life while offering the serenity of suburban living. Select from our spacious studio, one, two, or three-bedroom floor plans.\n\nVisions prides itself on offering premium amenities, including a contemporary fitness center, inviting pool, and private balconies with stunning views. Our pet-friendly environment and smoke-free policy enhance the quality of living. Additionally, residents benefit from convenient online payments. Located in Sun City Lakes, Visions presents a unique blend of community and privacy for those attending Midwestern University.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Find Apartments Near Midwestern University – Visions",
      "seo_description": "Visions in Peoria offers ideal living with easy access to Midwestern University in Maricopa County. Discover stylish apartments today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "living-options-near-sky-view-elementary-peoria",
      "search_query": "living options near sky view elementary school peoria",
      "category": "School",
      "h1_title": "Living Options Near Sky View Elementary",
      "h2_subtitle": "Explore excellent living options near Sky View Elementary School in Peoria. Visions offers welcoming accommodations for families and individuals alike.",
      "page_copy": "For those seeking comfortable living options near Sky View Elementary School in Peoria, Visions stands out as a top choice. Our community offers a relaxing atmosphere with spacious studio, one, two, and three-bedroom floor plans, perfect for families and individuals who wish to stay close to quality education.\n\nVisions provides an array of amenities that enhance everyday life, including a modern fitness center, a refreshing swimming pool, and private balconies. Our family-friendly and pet-friendly policies ensure that everyone feels at home here. With a smoke-free environment and a convenient location in the Sun City Lakes neighborhood, Visions is more than just an apartment complex—it's a welcoming community near Sky View Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Options Near Sky View Elementary – Visions",
      "seo_description": "Discover Visions in Peoria, offering ideal living options near Sky View Elementary School with family-friendly amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "apartments-near-desert-harbor-elementary",
      "search_query": "apartments near desert harbor elementary school sun city lakes fe",
      "category": "School",
      "h1_title": "Apartments Near Desert Harbor Elementary School",
      "h2_subtitle": "Explore top-rated apartments near Desert Harbor Elementary School in Sun City Lakes Fe. Visions offers family-friendly living options in Peoria.",
      "page_copy": "If you're on the lookout for apartments near Desert Harbor Elementary School in Sun City Lakes Fe, Visions is the perfect place to call home. Located in Peoria, our community is designed with families in mind, offering easy access to schools, shopping, and entertainment.\n\nVisions features a variety of floor plans, including spacious studio, one, two, and three-bedroom apartments. Enjoy amenities like a fully-equipped fitness center, a sparkling pool, and private balconies. Our pet-friendly environment and smoke-free policy add to the comfort and charm of living at Visions. With a focus on convenience and quality living, Visions makes it easy to settle into a welcoming community near Desert Harbor Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Desert Harbor Elementary School – Visions",
      "seo_description": "Visions in Peoria provides family-friendly apartments near Desert Harbor Elementary School, Sun City Lakes Fe. Ideal living with great amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "homes-close-to-peoria-high-school-85381",
      "search_query": "homes close to peoria high school 85381",
      "category": "School",
      "h1_title": "Homes Close to Peoria High School",
      "h2_subtitle": "Discover comfortable homes close to Peoria High School in the 85381 area. Visions offers ideal living with convenient amenities.",
      "page_copy": "Looking for homes close to Peoria High School in the 85381 area? Consider Visions, offering a convenient and welcoming community in Peoria. Our diverse selection of spacious studio, one, two, and three-bedroom apartment homes cater perfectly to families and individuals wanting proximity to education and lifestyle amenities.\n\nAt Visions, you'll enjoy a range of community features such as a state-of-the-art fitness center, beautiful swimming pool, and serene balconies overlooking the courtyard. Our smoke-free, pet-friendly environment supports a healthy and active lifestyle. Situated in the Sun City Lakes neighborhood, Visions provides easy access to Peoria High School, ensuring a smooth daily routine for students and families alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Close to Peoria High School – Visions",
      "seo_description": "Explore Visions in Peoria, offering homes close to Peoria High School 85381. Enjoy spacious living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "apartments-near-montessori-kingdom-learning-peoria",
      "search_query": "apartments near montessori kingdom of learning peoria",
      "category": "School",
      "h1_title": "Apartments Near Montessori Kingdom of Learning",
      "h2_subtitle": "Find top-tier apartments near Montessori Kingdom of Learning in Peoria. Visions offers a perfect blend of convenience and comfort.",
      "page_copy": "Searching for apartments near Montessori Kingdom of Learning in Peoria? Visions invites you to explore our vibrant community, just a short drive from this prestigious educational institution. Ideal for families valuing educational excellence, our location provides seamless access to what's important.\n\nVisions offers a variety of floor plans, including studio, one, two, and three-bedroom apartments, complete with modern amenities. Enjoy a refreshing swim in our pool, stay fit in our equipped fitness center, or relax on your private balcony. As a pet-friendly, smoke-free community, Visions ensures a peaceful living environment that complements your lifestyle demands while keeping you close to Montessori Kingdom of Learning.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Montessori Kingdom of Learning – Visions",
      "seo_description": "Explore Visions in Peoria for apartments near Montessori Kingdom of Learning, offering modern amenities and family-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5726763346821120",
      "property_id": "5185857371766784",
      "source": "generator",
      "page_item_url": "accommodations-near-aurora-day-school-peoria",
      "search_query": "accommodations near aurora day school peoria az",
      "category": "School",
      "h1_title": "Accommodations Near Aurora Day School",
      "h2_subtitle": "Explore premier accommodations near Aurora Day School in Peoria, AZ. Visions offers ideal living with modern amenities and convenience.",
      "page_copy": "If you're seeking accommodations near Aurora Day School in Peoria, AZ, Visions delivers the perfect blend of comfort and proximity. Our community is crafted to meet the needs of families and individuals seeking easy access to both education and a vibrant lifestyle.\n\nVisions provides a selection of spacious floor plans, including studio, one, two, and three-bedroom apartments. Indulge in delightful amenities like a fully-equipped fitness center, refreshing pool, and private balconies. Our pet-friendly and smoke-free environment enhances your living experience. Conveniently located in Peoria, Visions ensures easy commuting to Aurora Day School, making school runs hassle-free.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
      "featured_image_media": {
        "alt_text": "Modern kitchen with granite countertops and wooden cabinets.",
        "public_id": "019d019c-124f-744f-90fc-e22d722cf482",
        "storage_key": "property/5185857371766784/019d019c-124f-744f-90fc-e22d722cf482.webp",
        "width": 1024,
        "height": 683
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Accommodations Near Aurora Day School – Visions",
      "seo_description": "Visions offers accommodations near Aurora Day School in Peoria, AZ. Experience modern living with convenient access and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "4734"
    },
    {
      "ID": "custom_pixel_id",
      "type": "STRING",
      "value": "1035508496598043"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9147444446"
    },
    {
      "ID": "custom_text_us_url",
      "type": "STRING",
      "value": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6237451923"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W4ZD7MSV"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 1"
    },
    {
      "ID": "custom_rentgrata_token",
      "type": "STRING",
      "value": "71257baf-4654-431d-aeb0-3b98c332dca9"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Preferred"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_pricing_verbiage",
      "type": "STRING",
      "value": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more."
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a4ef689c-3167-4c7c-b7fb-679e742fb2b4/app.js?property=a4ef689c-3167-4c7c-b7fb-679e742fb2b4&propertyName=Visions&channelUuid=c2490e24-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "47715877006"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlJCb1lZRXNMZWQ5L1JIbnphWkpXMGc9PSIsInZhbHVlIjoiV2RaZUJPQ0drRnlUKytwMlVkM0ZVZz09IiwibWFjIjoiYTA5MWE2NTQ3ZjU4MTYyNGJhY2EyZjEwMGY4NTljNGRkNzFhMzc0YmZlYWFjMmY1ZDVmMmVlOGZmOTY0MjgzYiJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_qb_id": "4734",
  "custom_pixel_id": "1035508496598043",
  "custom_repli_id": "9147444446",
  "custom_text_us_url": "https://popcard.rentcafe.com/TextUsWidget.aspx?dnis=6237451923",
  "custom_google_gtm_id": "GTM-W4ZD7MSV",
  "custom_rollout_phase": "Phase 1",
  "custom_rentgrata_token": "71257baf-4654-431d-aeb0-3b98c332dca9",
  "custom_vibesites_theme": "Preferred",
  "custom_ads_subscription": "none",
  "custom_pricing_verbiage": "<strong>Featuring all-in-pricing.</strong> One total price, no hidden fees - just full transparency. With everything clearly listed so you can budget with certainty. Customize by adding parking, animals, and more.",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/conversations/a4ef689c-3167-4c7c-b7fb-679e742fb2b4/app.js?property=a4ef689c-3167-4c7c-b7fb-679e742fb2b4&propertyName=Visions&channelUuid=c2490e24-8dac-11ec-afb4-42010aa42b&buttonbgcolor=012345\" defer></script>",
  "custom_seo_subscription": "none",
  "custom_hubspot_company_id": "47715877006",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlJCb1lZRXNMZWQ5L1JIbnphWkpXMGc9PSIsInZhbHVlIjoiV2RaZUJPQ0drRnlUKytwMlVkM0ZVZz09IiwibWFjIjoiYTA5MWE2NTQ3ZjU4MTYyNGJhY2EyZjEwMGY4NTljNGRkNzFhMzc0YmZlYWFjMmY1ZDVmMmVlOGZmOTY0MjgzYiJ9",
  "custom_audioeye_site_id": "110a6c6b-fd47-4230-b1a9-b7953ede8d59",
  "custom_audioeye_site_hash": "67b9e60f5d762606fc1ff7e8667b1125"
};

export const generatedAt = '2026-10-27T17:05:57.787Z';
